"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.themeVars = void 0;
exports.themeVars = {
    sans: {
        display: {
            l: {
                'font-family': 'var(--sans-display-l-font-family, SB Sans Interface)',
                'font-weight': 'var(--sans-display-l-font-weight, Bold)',
                'line-height': 'var(--sans-display-l-line-height, 72px)',
                'font-size': 'var(--sans-display-l-font-size, 56px)',
                'letter-spacing': 'var(--sans-display-l-letter-spacing, -0.5px)',
                'paragraph-spacing': 'var(--sans-display-l-paragraph-spacing, 30.800000000000004px)'
            },
            m: {
                'font-family': 'var(--sans-display-m-font-family, SB Sans Interface)',
                'font-weight': 'var(--sans-display-m-font-weight, Semibold)',
                'line-height': 'var(--sans-display-m-line-height, 60px)',
                'font-size': 'var(--sans-display-m-font-size, 48px)',
                'letter-spacing': 'var(--sans-display-m-letter-spacing, -0.5px)',
                'paragraph-spacing': 'var(--sans-display-m-paragraph-spacing, 26.400000000000002px)'
            },
            s: {
                'font-family': 'var(--sans-display-s-font-family, SB Sans Interface)',
                'font-weight': 'var(--sans-display-s-font-weight, Semibold)',
                'line-height': 'var(--sans-display-s-line-height, 48px)',
                'font-size': 'var(--sans-display-s-font-size, 40px)',
                'letter-spacing': 'var(--sans-display-s-letter-spacing, -0.5px)',
                'paragraph-spacing': 'var(--sans-display-s-paragraph-spacing, 22px)'
            }
        },
        headline: {
            l: {
                'font-family': 'var(--sans-headline-l-font-family, SB Sans Interface)',
                'font-weight': 'var(--sans-headline-l-font-weight, Semibold)',
                'line-height': 'var(--sans-headline-l-line-height, 40px)',
                'font-size': 'var(--sans-headline-l-font-size, 32px)',
                'letter-spacing': 'var(--sans-headline-l-letter-spacing, -0.5px)',
                'paragraph-spacing': 'var(--sans-headline-l-paragraph-spacing, 17.6px)'
            },
            m: {
                'font-family': 'var(--sans-headline-m-font-family, SB Sans Interface)',
                'font-weight': 'var(--sans-headline-m-font-weight, Semibold)',
                'line-height': 'var(--sans-headline-m-line-height, 36px)',
                'font-size': 'var(--sans-headline-m-font-size, 28px)',
                'letter-spacing': 'var(--sans-headline-m-letter-spacing, -0.5px)',
                'paragraph-spacing': 'var(--sans-headline-m-paragraph-spacing, 15.400000000000002px)'
            },
            s: {
                'font-family': 'var(--sans-headline-s-font-family, SB Sans Interface)',
                'font-weight': 'var(--sans-headline-s-font-weight, Semibold)',
                'line-height': 'var(--sans-headline-s-line-height, 32px)',
                'font-size': 'var(--sans-headline-s-font-size, 24px)',
                'letter-spacing': 'var(--sans-headline-s-letter-spacing, -0.5px)',
                'paragraph-spacing': 'var(--sans-headline-s-paragraph-spacing, 13.200000000000001px)'
            }
        },
        title: {
            l: {
                'font-family': 'var(--sans-title-l-font-family, SB Sans Interface)',
                'font-weight': 'var(--sans-title-l-font-weight, Semibold)',
                'line-height': 'var(--sans-title-l-line-height, 28px)',
                'font-size': 'var(--sans-title-l-font-size, 20px)',
                'letter-spacing': 'var(--sans-title-l-letter-spacing, 0.15px)',
                'paragraph-spacing': 'var(--sans-title-l-paragraph-spacing, 11px)'
            },
            m: {
                'font-family': 'var(--sans-title-m-font-family, SB Sans Interface)',
                'font-weight': 'var(--sans-title-m-font-weight, Semibold)',
                'line-height': 'var(--sans-title-m-line-height, 24px)',
                'font-size': 'var(--sans-title-m-font-size, 16px)',
                'letter-spacing': 'var(--sans-title-m-letter-spacing, 0.15px)',
                'paragraph-spacing': 'var(--sans-title-m-paragraph-spacing, 8.8px)'
            },
            s: {
                'font-family': 'var(--sans-title-s-font-family, SB Sans Interface)',
                'font-weight': 'var(--sans-title-s-font-weight, Semibold)',
                'line-height': 'var(--sans-title-s-line-height, 20px)',
                'font-size': 'var(--sans-title-s-font-size, 14px)',
                'letter-spacing': 'var(--sans-title-s-letter-spacing, 0.15px)',
                'paragraph-spacing': 'var(--sans-title-s-paragraph-spacing, 7.700000000000001px)'
            }
        },
        label: {
            l: {
                'font-family': 'var(--sans-label-l-font-family, SB Sans Interface)',
                'font-weight': 'var(--sans-label-l-font-weight, Semibold)',
                'line-height': 'var(--sans-label-l-line-height, 20px)',
                'font-size': 'var(--sans-label-l-font-size, 14px)',
                'letter-spacing': 'var(--sans-label-l-letter-spacing, 0px)',
                'paragraph-spacing': 'var(--sans-label-l-paragraph-spacing, 7.700000000000001px)'
            },
            m: {
                'font-family': 'var(--sans-label-m-font-family, SB Sans Interface)',
                'font-weight': 'var(--sans-label-m-font-weight, Semibold)',
                'line-height': 'var(--sans-label-m-line-height, 16px)',
                'font-size': 'var(--sans-label-m-font-size, 12px)',
                'letter-spacing': 'var(--sans-label-m-letter-spacing, 0px)',
                'paragraph-spacing': 'var(--sans-label-m-paragraph-spacing, 6.6000000000000005px)'
            },
            s: {
                'font-family': 'var(--sans-label-s-font-family, SB Sans Interface)',
                'font-weight': 'var(--sans-label-s-font-weight, Semibold)',
                'line-height': 'var(--sans-label-s-line-height, 14px)',
                'font-size': 'var(--sans-label-s-font-size, 11px)',
                'letter-spacing': 'var(--sans-label-s-letter-spacing, 0px)',
                'paragraph-spacing': 'var(--sans-label-s-paragraph-spacing, 6.050000000000001px)'
            }
        },
        body: {
            l: {
                'font-family': 'var(--sans-body-l-font-family, SB Sans Interface)',
                'font-weight': 'var(--sans-body-l-font-weight, Regular)',
                'line-height': 'var(--sans-body-l-line-height, 24px)',
                'font-size': 'var(--sans-body-l-font-size, 16px)',
                'letter-spacing': 'var(--sans-body-l-letter-spacing, 0.1px)',
                'paragraph-spacing': 'var(--sans-body-l-paragraph-spacing, 8.8px)'
            },
            m: {
                'font-family': 'var(--sans-body-m-font-family, SB Sans Interface)',
                'font-weight': 'var(--sans-body-m-font-weight, Regular)',
                'line-height': 'var(--sans-body-m-line-height, 20px)',
                'font-size': 'var(--sans-body-m-font-size, 14px)',
                'letter-spacing': 'var(--sans-body-m-letter-spacing, 0.1px)',
                'paragraph-spacing': 'var(--sans-body-m-paragraph-spacing, 7.700000000000001px)'
            },
            s: {
                'font-family': 'var(--sans-body-s-font-family, SB Sans Interface)',
                'font-weight': 'var(--sans-body-s-font-weight, Regular)',
                'line-height': 'var(--sans-body-s-line-height, 16px)',
                'font-size': 'var(--sans-body-s-font-size, 12px)',
                'letter-spacing': 'var(--sans-body-s-letter-spacing, 0.1px)',
                'paragraph-spacing': 'var(--sans-body-s-paragraph-spacing, 6.6000000000000005px)'
            }
        }
    },
    light: {
        display: {
            l: {
                'font-family': 'var(--light-display-l-font-family, SB Sans Interface)',
                'font-weight': 'var(--light-display-l-font-weight, Regular)',
                'line-height': 'var(--light-display-l-line-height, 72px)',
                'font-size': 'var(--light-display-l-font-size, 56px)',
                'letter-spacing': 'var(--light-display-l-letter-spacing, -0.5px)',
                'paragraph-spacing': 'var(--light-display-l-paragraph-spacing, 30.800000000000004px)'
            },
            m: {
                'font-family': 'var(--light-display-m-font-family, SB Sans Interface)',
                'font-weight': 'var(--light-display-m-font-weight, Regular)',
                'line-height': 'var(--light-display-m-line-height, 60px)',
                'font-size': 'var(--light-display-m-font-size, 48px)',
                'letter-spacing': 'var(--light-display-m-letter-spacing, -0.5px)',
                'paragraph-spacing': 'var(--light-display-m-paragraph-spacing, 26.400000000000002px)'
            },
            s: {
                'font-family': 'var(--light-display-s-font-family, SB Sans Interface)',
                'font-weight': 'var(--light-display-s-font-weight, Regular)',
                'line-height': 'var(--light-display-s-line-height, 48px)',
                'font-size': 'var(--light-display-s-font-size, 40px)',
                'letter-spacing': 'var(--light-display-s-letter-spacing, -0.5px)',
                'paragraph-spacing': 'var(--light-display-s-paragraph-spacing, 22px)'
            }
        },
        headline: {
            l: {
                'font-family': 'var(--light-headline-l-font-family, SB Sans Interface)',
                'font-weight': 'var(--light-headline-l-font-weight, Regular)',
                'line-height': 'var(--light-headline-l-line-height, 40px)',
                'font-size': 'var(--light-headline-l-font-size, 32px)',
                'letter-spacing': 'var(--light-headline-l-letter-spacing, -0.5px)',
                'paragraph-spacing': 'var(--light-headline-l-paragraph-spacing, 17.6px)'
            },
            m: {
                'font-family': 'var(--light-headline-m-font-family, SB Sans Interface)',
                'font-weight': 'var(--light-headline-m-font-weight, Regular)',
                'line-height': 'var(--light-headline-m-line-height, 36px)',
                'font-size': 'var(--light-headline-m-font-size, 28px)',
                'letter-spacing': 'var(--light-headline-m-letter-spacing, -0.5px)',
                'paragraph-spacing': 'var(--light-headline-m-paragraph-spacing, 15.400000000000002px)'
            },
            s: {
                'font-family': 'var(--light-headline-s-font-family, SB Sans Interface)',
                'font-weight': 'var(--light-headline-s-font-weight, Regular)',
                'line-height': 'var(--light-headline-s-line-height, 32px)',
                'font-size': 'var(--light-headline-s-font-size, 24px)',
                'letter-spacing': 'var(--light-headline-s-letter-spacing, -0.5px)',
                'paragraph-spacing': 'var(--light-headline-s-paragraph-spacing, 13.200000000000001px)'
            }
        },
        title: {
            l: {
                'font-family': 'var(--light-title-l-font-family, SB Sans Interface)',
                'font-weight': 'var(--light-title-l-font-weight, Regular)',
                'line-height': 'var(--light-title-l-line-height, 28px)',
                'font-size': 'var(--light-title-l-font-size, 20px)',
                'letter-spacing': 'var(--light-title-l-letter-spacing, 0.15px)',
                'paragraph-spacing': 'var(--light-title-l-paragraph-spacing, 11px)'
            },
            m: {
                'font-family': 'var(--light-title-m-font-family, SB Sans Interface)',
                'font-weight': 'var(--light-title-m-font-weight, Regular)',
                'line-height': 'var(--light-title-m-line-height, 24px)',
                'font-size': 'var(--light-title-m-font-size, 16px)',
                'letter-spacing': 'var(--light-title-m-letter-spacing, 0.15px)',
                'paragraph-spacing': 'var(--light-title-m-paragraph-spacing, 8.8px)'
            },
            s: {
                'font-family': 'var(--light-title-s-font-family, SB Sans Interface)',
                'font-weight': 'var(--light-title-s-font-weight, Regular)',
                'line-height': 'var(--light-title-s-line-height, 20px)',
                'font-size': 'var(--light-title-s-font-size, 14px)',
                'letter-spacing': 'var(--light-title-s-letter-spacing, 0.15px)',
                'paragraph-spacing': 'var(--light-title-s-paragraph-spacing, 7.700000000000001px)'
            }
        },
        label: {
            l: {
                'font-family': 'var(--light-label-l-font-family, SB Sans Interface)',
                'font-weight': 'var(--light-label-l-font-weight, Regular)',
                'line-height': 'var(--light-label-l-line-height, 20px)',
                'font-size': 'var(--light-label-l-font-size, 14px)',
                'letter-spacing': 'var(--light-label-l-letter-spacing, 0px)',
                'paragraph-spacing': 'var(--light-label-l-paragraph-spacing, 7.700000000000001px)'
            },
            m: {
                'font-family': 'var(--light-label-m-font-family, SB Sans Interface)',
                'font-weight': 'var(--light-label-m-font-weight, Regular)',
                'line-height': 'var(--light-label-m-line-height, 16px)',
                'font-size': 'var(--light-label-m-font-size, 12px)',
                'letter-spacing': 'var(--light-label-m-letter-spacing, 0px)',
                'paragraph-spacing': 'var(--light-label-m-paragraph-spacing, 6.6000000000000005px)'
            },
            s: {
                'font-family': 'var(--light-label-s-font-family, SB Sans Interface)',
                'font-weight': 'var(--light-label-s-font-weight, Regular)',
                'line-height': 'var(--light-label-s-line-height, 14px)',
                'font-size': 'var(--light-label-s-font-size, 11px)',
                'letter-spacing': 'var(--light-label-s-letter-spacing, 0px)',
                'paragraph-spacing': 'var(--light-label-s-paragraph-spacing, 6.050000000000001px)'
            }
        },
        body: {
            l: {
                'font-family': 'var(--light-body-l-font-family, SB Sans Interface)',
                'font-weight': 'var(--light-body-l-font-weight, Light)',
                'line-height': 'var(--light-body-l-line-height, 24px)',
                'font-size': 'var(--light-body-l-font-size, 16px)',
                'letter-spacing': 'var(--light-body-l-letter-spacing, 0.1px)',
                'paragraph-spacing': 'var(--light-body-l-paragraph-spacing, 8.8px)'
            },
            m: {
                'font-family': 'var(--light-body-m-font-family, SB Sans Interface)',
                'font-weight': 'var(--light-body-m-font-weight, Light)',
                'line-height': 'var(--light-body-m-line-height, 20px)',
                'font-size': 'var(--light-body-m-font-size, 14px)',
                'letter-spacing': 'var(--light-body-m-letter-spacing, 0.1px)',
                'paragraph-spacing': 'var(--light-body-m-paragraph-spacing, 7.700000000000001px)'
            },
            s: {
                'font-family': 'var(--light-body-s-font-family, SB Sans Interface)',
                'font-weight': 'var(--light-body-s-font-weight, Light)',
                'line-height': 'var(--light-body-s-line-height, 16px)',
                'font-size': 'var(--light-body-s-font-size, 12px)',
                'letter-spacing': 'var(--light-body-s-letter-spacing, 0.1px)',
                'paragraph-spacing': 'var(--light-body-s-paragraph-spacing, 6.6000000000000005px)'
            }
        }
    },
    link: {
        display: {
            l: {
                'font-family': 'var(--link-display-l-font-family, SB Sans Interface)',
                'font-weight': 'var(--link-display-l-font-weight, Bold)',
                'line-height': 'var(--link-display-l-line-height, 72px)',
                'font-size': 'var(--link-display-l-font-size, 56px)',
                'letter-spacing': 'var(--link-display-l-letter-spacing, -0.5px)',
                'paragraph-spacing': 'var(--link-display-l-paragraph-spacing, 30.800000000000004px)',
                'text-decoration': 'var(--link-display-l-text-decoration, underline)'
            },
            m: {
                'font-family': 'var(--link-display-m-font-family, SB Sans Interface)',
                'font-weight': 'var(--link-display-m-font-weight, Semibold)',
                'line-height': 'var(--link-display-m-line-height, 60px)',
                'font-size': 'var(--link-display-m-font-size, 48px)',
                'letter-spacing': 'var(--link-display-m-letter-spacing, -0.5px)',
                'paragraph-spacing': 'var(--link-display-m-paragraph-spacing, 26.400000000000002px)',
                'text-decoration': 'var(--link-display-m-text-decoration, underline)'
            },
            s: {
                'font-family': 'var(--link-display-s-font-family, SB Sans Interface)',
                'font-weight': 'var(--link-display-s-font-weight, Semibold)',
                'line-height': 'var(--link-display-s-line-height, 48px)',
                'font-size': 'var(--link-display-s-font-size, 40px)',
                'letter-spacing': 'var(--link-display-s-letter-spacing, -0.5px)',
                'paragraph-spacing': 'var(--link-display-s-paragraph-spacing, 22px)',
                'text-decoration': 'var(--link-display-s-text-decoration, underline)'
            }
        },
        headline: {
            l: {
                'font-family': 'var(--link-headline-l-font-family, SB Sans Interface)',
                'font-weight': 'var(--link-headline-l-font-weight, Semibold)',
                'line-height': 'var(--link-headline-l-line-height, 40px)',
                'font-size': 'var(--link-headline-l-font-size, 32px)',
                'letter-spacing': 'var(--link-headline-l-letter-spacing, -0.5px)',
                'paragraph-spacing': 'var(--link-headline-l-paragraph-spacing, 17.6px)',
                'text-decoration': 'var(--link-headline-l-text-decoration, underline)'
            },
            m: {
                'font-family': 'var(--link-headline-m-font-family, SB Sans Interface)',
                'font-weight': 'var(--link-headline-m-font-weight, Semibold)',
                'line-height': 'var(--link-headline-m-line-height, 36px)',
                'font-size': 'var(--link-headline-m-font-size, 28px)',
                'letter-spacing': 'var(--link-headline-m-letter-spacing, -0.5px)',
                'paragraph-spacing': 'var(--link-headline-m-paragraph-spacing, 15.400000000000002px)',
                'text-decoration': 'var(--link-headline-m-text-decoration, underline)'
            },
            s: {
                'font-family': 'var(--link-headline-s-font-family, SB Sans Interface)',
                'font-weight': 'var(--link-headline-s-font-weight, Semibold)',
                'line-height': 'var(--link-headline-s-line-height, 32px)',
                'font-size': 'var(--link-headline-s-font-size, 24px)',
                'letter-spacing': 'var(--link-headline-s-letter-spacing, -0.5px)',
                'paragraph-spacing': 'var(--link-headline-s-paragraph-spacing, 13.200000000000001px)',
                'text-decoration': 'var(--link-headline-s-text-decoration, underline)'
            }
        },
        title: {
            l: {
                'font-family': 'var(--link-title-l-font-family, SB Sans Interface)',
                'font-weight': 'var(--link-title-l-font-weight, Semibold)',
                'line-height': 'var(--link-title-l-line-height, 28px)',
                'font-size': 'var(--link-title-l-font-size, 20px)',
                'letter-spacing': 'var(--link-title-l-letter-spacing, 0.15px)',
                'paragraph-spacing': 'var(--link-title-l-paragraph-spacing, 11px)',
                'text-decoration': 'var(--link-title-l-text-decoration, underline)'
            },
            m: {
                'font-family': 'var(--link-title-m-font-family, SB Sans Interface)',
                'font-weight': 'var(--link-title-m-font-weight, Semibold)',
                'line-height': 'var(--link-title-m-line-height, 24px)',
                'font-size': 'var(--link-title-m-font-size, 16px)',
                'letter-spacing': 'var(--link-title-m-letter-spacing, 0.15px)',
                'paragraph-spacing': 'var(--link-title-m-paragraph-spacing, 8.8px)',
                'text-decoration': 'var(--link-title-m-text-decoration, underline)'
            },
            s: {
                'font-family': 'var(--link-title-s-font-family, SB Sans Interface)',
                'font-weight': 'var(--link-title-s-font-weight, Semibold)',
                'line-height': 'var(--link-title-s-line-height, 20px)',
                'font-size': 'var(--link-title-s-font-size, 14px)',
                'letter-spacing': 'var(--link-title-s-letter-spacing, 0.15px)',
                'paragraph-spacing': 'var(--link-title-s-paragraph-spacing, 7.700000000000001px)',
                'text-decoration': 'var(--link-title-s-text-decoration, underline)'
            }
        },
        label: {
            l: {
                'font-family': 'var(--link-label-l-font-family, SB Sans Interface)',
                'font-weight': 'var(--link-label-l-font-weight, Semibold)',
                'line-height': 'var(--link-label-l-line-height, 20px)',
                'font-size': 'var(--link-label-l-font-size, 14px)',
                'letter-spacing': 'var(--link-label-l-letter-spacing, 0px)',
                'paragraph-spacing': 'var(--link-label-l-paragraph-spacing, 7.700000000000001px)',
                'text-decoration': 'var(--link-label-l-text-decoration, underline)'
            },
            m: {
                'font-family': 'var(--link-label-m-font-family, SB Sans Interface)',
                'font-weight': 'var(--link-label-m-font-weight, Semibold)',
                'line-height': 'var(--link-label-m-line-height, 16px)',
                'font-size': 'var(--link-label-m-font-size, 12px)',
                'letter-spacing': 'var(--link-label-m-letter-spacing, 0px)',
                'paragraph-spacing': 'var(--link-label-m-paragraph-spacing, 6.6000000000000005px)',
                'text-decoration': 'var(--link-label-m-text-decoration, underline)'
            },
            s: {
                'font-family': 'var(--link-label-s-font-family, SB Sans Interface)',
                'font-weight': 'var(--link-label-s-font-weight, Semibold)',
                'line-height': 'var(--link-label-s-line-height, 14px)',
                'font-size': 'var(--link-label-s-font-size, 11px)',
                'letter-spacing': 'var(--link-label-s-letter-spacing, 0px)',
                'paragraph-spacing': 'var(--link-label-s-paragraph-spacing, 6.050000000000001px)',
                'text-decoration': 'var(--link-label-s-text-decoration, underline)'
            }
        },
        body: {
            l: {
                'font-family': 'var(--link-body-l-font-family, SB Sans Interface)',
                'font-weight': 'var(--link-body-l-font-weight, Regular)',
                'line-height': 'var(--link-body-l-line-height, 24px)',
                'font-size': 'var(--link-body-l-font-size, 16px)',
                'letter-spacing': 'var(--link-body-l-letter-spacing, 0.1px)',
                'paragraph-spacing': 'var(--link-body-l-paragraph-spacing, 8.8px)',
                'text-decoration': 'var(--link-body-l-text-decoration, underline)'
            },
            m: {
                'font-family': 'var(--link-body-m-font-family, SB Sans Interface)',
                'font-weight': 'var(--link-body-m-font-weight, Regular)',
                'line-height': 'var(--link-body-m-line-height, 20px)',
                'font-size': 'var(--link-body-m-font-size, 14px)',
                'letter-spacing': 'var(--link-body-m-letter-spacing, 0.1px)',
                'paragraph-spacing': 'var(--link-body-m-paragraph-spacing, 7.700000000000001px)',
                'text-decoration': 'var(--link-body-m-text-decoration, underline)'
            },
            s: {
                'font-family': 'var(--link-body-s-font-family, SB Sans Interface)',
                'font-weight': 'var(--link-body-s-font-weight, Regular)',
                'line-height': 'var(--link-body-s-line-height, 16px)',
                'font-size': 'var(--link-body-s-font-size, 12px)',
                'letter-spacing': 'var(--link-body-s-letter-spacing, 0.1px)',
                'paragraph-spacing': 'var(--link-body-s-paragraph-spacing, 6.6000000000000005px)',
                'text-decoration': 'var(--link-body-s-text-decoration, underline)'
            }
        }
    },
    crossedOut: {
        display: {
            l: {
                'font-family': 'var(--crossed-out-display-l-font-family, SB Sans Interface)',
                'font-weight': 'var(--crossed-out-display-l-font-weight, Bold)',
                'line-height': 'var(--crossed-out-display-l-line-height, 72px)',
                'font-size': 'var(--crossed-out-display-l-font-size, 56px)',
                'letter-spacing': 'var(--crossed-out-display-l-letter-spacing, -0.5px)',
                'paragraph-spacing': 'var(--crossed-out-display-l-paragraph-spacing, 30.800000000000004px)',
                'text-decoration': 'var(--crossed-out-display-l-text-decoration, line-through)'
            },
            m: {
                'font-family': 'var(--crossed-out-display-m-font-family, SB Sans Interface)',
                'font-weight': 'var(--crossed-out-display-m-font-weight, Semibold)',
                'line-height': 'var(--crossed-out-display-m-line-height, 60px)',
                'font-size': 'var(--crossed-out-display-m-font-size, 48px)',
                'letter-spacing': 'var(--crossed-out-display-m-letter-spacing, -0.5px)',
                'paragraph-spacing': 'var(--crossed-out-display-m-paragraph-spacing, 26.400000000000002px)',
                'text-decoration': 'var(--crossed-out-display-m-text-decoration, line-through)'
            },
            s: {
                'font-family': 'var(--crossed-out-display-s-font-family, SB Sans Interface)',
                'font-weight': 'var(--crossed-out-display-s-font-weight, Semibold)',
                'line-height': 'var(--crossed-out-display-s-line-height, 48px)',
                'font-size': 'var(--crossed-out-display-s-font-size, 40px)',
                'letter-spacing': 'var(--crossed-out-display-s-letter-spacing, -0.5px)',
                'paragraph-spacing': 'var(--crossed-out-display-s-paragraph-spacing, 22px)',
                'text-decoration': 'var(--crossed-out-display-s-text-decoration, line-through)'
            }
        },
        headline: {
            l: {
                'font-family': 'var(--crossed-out-headline-l-font-family, SB Sans Interface)',
                'font-weight': 'var(--crossed-out-headline-l-font-weight, Semibold)',
                'line-height': 'var(--crossed-out-headline-l-line-height, 40px)',
                'font-size': 'var(--crossed-out-headline-l-font-size, 32px)',
                'letter-spacing': 'var(--crossed-out-headline-l-letter-spacing, -0.5px)',
                'paragraph-spacing': 'var(--crossed-out-headline-l-paragraph-spacing, 17.6px)',
                'text-decoration': 'var(--crossed-out-headline-l-text-decoration, line-through)'
            },
            m: {
                'font-family': 'var(--crossed-out-headline-m-font-family, SB Sans Interface)',
                'font-weight': 'var(--crossed-out-headline-m-font-weight, Semibold)',
                'line-height': 'var(--crossed-out-headline-m-line-height, 36px)',
                'font-size': 'var(--crossed-out-headline-m-font-size, 28px)',
                'letter-spacing': 'var(--crossed-out-headline-m-letter-spacing, -0.5px)',
                'paragraph-spacing': 'var(--crossed-out-headline-m-paragraph-spacing, 15.400000000000002px)',
                'text-decoration': 'var(--crossed-out-headline-m-text-decoration, line-through)'
            },
            s: {
                'font-family': 'var(--crossed-out-headline-s-font-family, SB Sans Interface)',
                'font-weight': 'var(--crossed-out-headline-s-font-weight, Semibold)',
                'line-height': 'var(--crossed-out-headline-s-line-height, 32px)',
                'font-size': 'var(--crossed-out-headline-s-font-size, 24px)',
                'letter-spacing': 'var(--crossed-out-headline-s-letter-spacing, -0.5px)',
                'paragraph-spacing': 'var(--crossed-out-headline-s-paragraph-spacing, 13.200000000000001px)',
                'text-decoration': 'var(--crossed-out-headline-s-text-decoration, line-through)'
            }
        },
        title: {
            l: {
                'font-family': 'var(--crossed-out-title-l-font-family, SB Sans Interface)',
                'font-weight': 'var(--crossed-out-title-l-font-weight, Semibold)',
                'line-height': 'var(--crossed-out-title-l-line-height, 28px)',
                'font-size': 'var(--crossed-out-title-l-font-size, 20px)',
                'letter-spacing': 'var(--crossed-out-title-l-letter-spacing, 0.15px)',
                'paragraph-spacing': 'var(--crossed-out-title-l-paragraph-spacing, 11px)',
                'text-decoration': 'var(--crossed-out-title-l-text-decoration, line-through)'
            },
            m: {
                'font-family': 'var(--crossed-out-title-m-font-family, SB Sans Interface)',
                'font-weight': 'var(--crossed-out-title-m-font-weight, Semibold)',
                'line-height': 'var(--crossed-out-title-m-line-height, 24px)',
                'font-size': 'var(--crossed-out-title-m-font-size, 16px)',
                'letter-spacing': 'var(--crossed-out-title-m-letter-spacing, 0.15px)',
                'paragraph-spacing': 'var(--crossed-out-title-m-paragraph-spacing, 8.8px)',
                'text-decoration': 'var(--crossed-out-title-m-text-decoration, line-through)'
            },
            s: {
                'font-family': 'var(--crossed-out-title-s-font-family, SB Sans Interface)',
                'font-weight': 'var(--crossed-out-title-s-font-weight, Semibold)',
                'line-height': 'var(--crossed-out-title-s-line-height, 20px)',
                'font-size': 'var(--crossed-out-title-s-font-size, 14px)',
                'letter-spacing': 'var(--crossed-out-title-s-letter-spacing, 0.15px)',
                'paragraph-spacing': 'var(--crossed-out-title-s-paragraph-spacing, 7.700000000000001px)',
                'text-decoration': 'var(--crossed-out-title-s-text-decoration, line-through)'
            }
        },
        label: {
            l: {
                'font-family': 'var(--crossed-out-label-l-font-family, SB Sans Interface)',
                'font-weight': 'var(--crossed-out-label-l-font-weight, Semibold)',
                'line-height': 'var(--crossed-out-label-l-line-height, 20px)',
                'font-size': 'var(--crossed-out-label-l-font-size, 14px)',
                'letter-spacing': 'var(--crossed-out-label-l-letter-spacing, 0px)',
                'paragraph-spacing': 'var(--crossed-out-label-l-paragraph-spacing, 7.700000000000001px)',
                'text-decoration': 'var(--crossed-out-label-l-text-decoration, line-through)'
            },
            m: {
                'font-family': 'var(--crossed-out-label-m-font-family, SB Sans Interface)',
                'font-weight': 'var(--crossed-out-label-m-font-weight, Semibold)',
                'line-height': 'var(--crossed-out-label-m-line-height, 16px)',
                'font-size': 'var(--crossed-out-label-m-font-size, 12px)',
                'letter-spacing': 'var(--crossed-out-label-m-letter-spacing, 0px)',
                'paragraph-spacing': 'var(--crossed-out-label-m-paragraph-spacing, 6.6000000000000005px)',
                'text-decoration': 'var(--crossed-out-label-m-text-decoration, line-through)'
            },
            s: {
                'font-family': 'var(--crossed-out-label-s-font-family, SB Sans Interface)',
                'font-weight': 'var(--crossed-out-label-s-font-weight, Semibold)',
                'line-height': 'var(--crossed-out-label-s-line-height, 14px)',
                'font-size': 'var(--crossed-out-label-s-font-size, 11px)',
                'letter-spacing': 'var(--crossed-out-label-s-letter-spacing, 0px)',
                'paragraph-spacing': 'var(--crossed-out-label-s-paragraph-spacing, 6.050000000000001px)',
                'text-decoration': 'var(--crossed-out-label-s-text-decoration, line-through)'
            }
        },
        body: {
            l: {
                'font-family': 'var(--crossed-out-body-l-font-family, SB Sans Interface)',
                'font-weight': 'var(--crossed-out-body-l-font-weight, Regular)',
                'line-height': 'var(--crossed-out-body-l-line-height, 24px)',
                'font-size': 'var(--crossed-out-body-l-font-size, 16px)',
                'letter-spacing': 'var(--crossed-out-body-l-letter-spacing, 0.1px)',
                'paragraph-spacing': 'var(--crossed-out-body-l-paragraph-spacing, 8.8px)',
                'text-decoration': 'var(--crossed-out-body-l-text-decoration, line-through)'
            },
            m: {
                'font-family': 'var(--crossed-out-body-m-font-family, SB Sans Interface)',
                'font-weight': 'var(--crossed-out-body-m-font-weight, Regular)',
                'line-height': 'var(--crossed-out-body-m-line-height, 20px)',
                'font-size': 'var(--crossed-out-body-m-font-size, 14px)',
                'letter-spacing': 'var(--crossed-out-body-m-letter-spacing, 0.1px)',
                'paragraph-spacing': 'var(--crossed-out-body-m-paragraph-spacing, 7.700000000000001px)',
                'text-decoration': 'var(--crossed-out-body-m-text-decoration, line-through)'
            },
            s: {
                'font-family': 'var(--crossed-out-body-s-font-family, SB Sans Interface)',
                'font-weight': 'var(--crossed-out-body-s-font-weight, Regular)',
                'line-height': 'var(--crossed-out-body-s-line-height, 16px)',
                'font-size': 'var(--crossed-out-body-s-font-size, 12px)',
                'letter-spacing': 'var(--crossed-out-body-s-letter-spacing, 0.1px)',
                'paragraph-spacing': 'var(--crossed-out-body-s-paragraph-spacing, 6.6000000000000005px)',
                'text-decoration': 'var(--crossed-out-body-s-text-decoration, line-through)'
            }
        }
    },
    mono: {
        display: {
            l: {
                'font-family': 'var(--mono-display-l-font-family, SB Sans Text Mono)',
                'font-weight': 'var(--mono-display-l-font-weight, Bold)',
                'line-height': 'var(--mono-display-l-line-height, 72px)',
                'font-size': 'var(--mono-display-l-font-size, 56px)',
                'letter-spacing': 'var(--mono-display-l-letter-spacing, -0.5px)',
                'paragraph-spacing': 'var(--mono-display-l-paragraph-spacing, 30.800000000000004px)'
            },
            m: {
                'font-family': 'var(--mono-display-m-font-family, SB Sans Text Mono)',
                'font-weight': 'var(--mono-display-m-font-weight, Bold)',
                'line-height': 'var(--mono-display-m-line-height, 60px)',
                'font-size': 'var(--mono-display-m-font-size, 48px)',
                'letter-spacing': 'var(--mono-display-m-letter-spacing, -0.5px)',
                'paragraph-spacing': 'var(--mono-display-m-paragraph-spacing, 26.400000000000002px)'
            },
            s: {
                'font-family': 'var(--mono-display-s-font-family, SB Sans Text Mono)',
                'font-weight': 'var(--mono-display-s-font-weight, Bold)',
                'line-height': 'var(--mono-display-s-line-height, 48px)',
                'font-size': 'var(--mono-display-s-font-size, 40px)',
                'letter-spacing': 'var(--mono-display-s-letter-spacing, -0.5px)',
                'paragraph-spacing': 'var(--mono-display-s-paragraph-spacing, 22px)'
            }
        },
        headline: {
            l: {
                'font-family': 'var(--mono-headline-l-font-family, SB Sans Text Mono)',
                'font-weight': 'var(--mono-headline-l-font-weight, Bold)',
                'line-height': 'var(--mono-headline-l-line-height, 40px)',
                'font-size': 'var(--mono-headline-l-font-size, 32px)',
                'letter-spacing': 'var(--mono-headline-l-letter-spacing, -0.5px)',
                'paragraph-spacing': 'var(--mono-headline-l-paragraph-spacing, 17.6px)'
            },
            m: {
                'font-family': 'var(--mono-headline-m-font-family, SB Sans Text Mono)',
                'font-weight': 'var(--mono-headline-m-font-weight, Bold)',
                'line-height': 'var(--mono-headline-m-line-height, 36px)',
                'font-size': 'var(--mono-headline-m-font-size, 28px)',
                'letter-spacing': 'var(--mono-headline-m-letter-spacing, -0.5px)',
                'paragraph-spacing': 'var(--mono-headline-m-paragraph-spacing, 15.400000000000002px)'
            },
            s: {
                'font-family': 'var(--mono-headline-s-font-family, SB Sans Text Mono)',
                'font-weight': 'var(--mono-headline-s-font-weight, Bold)',
                'line-height': 'var(--mono-headline-s-line-height, 32px)',
                'font-size': 'var(--mono-headline-s-font-size, 24px)',
                'letter-spacing': 'var(--mono-headline-s-letter-spacing, -0.5px)',
                'paragraph-spacing': 'var(--mono-headline-s-paragraph-spacing, 13.200000000000001px)'
            }
        },
        title: {
            l: {
                'font-family': 'var(--mono-title-l-font-family, SB Sans Text Mono)',
                'font-weight': 'var(--mono-title-l-font-weight, Regular)',
                'line-height': 'var(--mono-title-l-line-height, 28px)',
                'font-size': 'var(--mono-title-l-font-size, 20px)',
                'letter-spacing': 'var(--mono-title-l-letter-spacing, 0.15px)',
                'paragraph-spacing': 'var(--mono-title-l-paragraph-spacing, 11px)'
            },
            m: {
                'font-family': 'var(--mono-title-m-font-family, SB Sans Text Mono)',
                'font-weight': 'var(--mono-title-m-font-weight, Regular)',
                'line-height': 'var(--mono-title-m-line-height, 24px)',
                'font-size': 'var(--mono-title-m-font-size, 16px)',
                'letter-spacing': 'var(--mono-title-m-letter-spacing, 0.15px)',
                'paragraph-spacing': 'var(--mono-title-m-paragraph-spacing, 8.8px)'
            },
            s: {
                'font-family': 'var(--mono-title-s-font-family, SB Sans Text Mono)',
                'font-weight': 'var(--mono-title-s-font-weight, Regular)',
                'line-height': 'var(--mono-title-s-line-height, 20px)',
                'font-size': 'var(--mono-title-s-font-size, 14px)',
                'letter-spacing': 'var(--mono-title-s-letter-spacing, 0.15px)',
                'paragraph-spacing': 'var(--mono-title-s-paragraph-spacing, 7.700000000000001px)'
            }
        },
        label: {
            l: {
                'font-family': 'var(--mono-label-l-font-family, SB Sans Text Mono)',
                'font-weight': 'var(--mono-label-l-font-weight, Bold)',
                'line-height': 'var(--mono-label-l-line-height, 20px)',
                'font-size': 'var(--mono-label-l-font-size, 14px)',
                'letter-spacing': 'var(--mono-label-l-letter-spacing, 0px)',
                'paragraph-spacing': 'var(--mono-label-l-paragraph-spacing, 7.700000000000001px)'
            },
            m: {
                'font-family': 'var(--mono-label-m-font-family, SB Sans Text Mono)',
                'font-weight': 'var(--mono-label-m-font-weight, Bold)',
                'line-height': 'var(--mono-label-m-line-height, 16px)',
                'font-size': 'var(--mono-label-m-font-size, 12px)',
                'letter-spacing': 'var(--mono-label-m-letter-spacing, 0px)',
                'paragraph-spacing': 'var(--mono-label-m-paragraph-spacing, 6.6000000000000005px)'
            },
            s: {
                'font-family': 'var(--mono-label-s-font-family, SB Sans Text Mono)',
                'font-weight': 'var(--mono-label-s-font-weight, Bold)',
                'line-height': 'var(--mono-label-s-line-height, 14px)',
                'font-size': 'var(--mono-label-s-font-size, 11px)',
                'letter-spacing': 'var(--mono-label-s-letter-spacing, 0px)',
                'paragraph-spacing': 'var(--mono-label-s-paragraph-spacing, 6.050000000000001px)'
            }
        },
        body: {
            l: {
                'font-family': 'var(--mono-body-l-font-family, SB Sans Text Mono)',
                'font-weight': 'var(--mono-body-l-font-weight, Regular)',
                'line-height': 'var(--mono-body-l-line-height, 24px)',
                'font-size': 'var(--mono-body-l-font-size, 16px)',
                'letter-spacing': 'var(--mono-body-l-letter-spacing, 0.1px)',
                'paragraph-spacing': 'var(--mono-body-l-paragraph-spacing, 8.8px)'
            },
            m: {
                'font-family': 'var(--mono-body-m-font-family, SB Sans Text Mono)',
                'font-weight': 'var(--mono-body-m-font-weight, Regular)',
                'line-height': 'var(--mono-body-m-line-height, 20px)',
                'font-size': 'var(--mono-body-m-font-size, 14px)',
                'letter-spacing': 'var(--mono-body-m-letter-spacing, 0.1px)',
                'paragraph-spacing': 'var(--mono-body-m-paragraph-spacing, 7.700000000000001px)'
            },
            s: {
                'font-family': 'var(--mono-body-s-font-family, SB Sans Text Mono)',
                'font-weight': 'var(--mono-body-s-font-weight, Regular)',
                'line-height': 'var(--mono-body-s-line-height, 16px)',
                'font-size': 'var(--mono-body-s-font-size, 12px)',
                'letter-spacing': 'var(--mono-body-s-letter-spacing, 0.1px)',
                'paragraph-spacing': 'var(--mono-body-s-paragraph-spacing, 6.6000000000000005px)'
            }
        }
    },
    boxShadow: {
        elevation: {
            level1: 'var(--box-shadow-elevation-level1, 0px 0px 4px 0px #0000000a, 0px 2px 4px 0px #0000000a)',
            level2: 'var(--box-shadow-elevation-level2, 0px 0px 4px 0px #0000000a, 0px 4px 8px 0px #0000000a)',
            level3: 'var(--box-shadow-elevation-level3, 0px 0px 8px 0px #00000014, 0px 8px 16px 0px #00000014)',
            level4: 'var(--box-shadow-elevation-level4, 0px 0px 8px 0px #00000014, 0px 16px 16px 0px #00000014)',
            level5: 'var(--box-shadow-elevation-level5, 0px 0px 16px 0px #00000014, 0px 24px 16px 0px #00000014)'
        }
    },
    backgroundBlur: {
        'background-blur': 'var(--background-blur-background-blur, 16px)'
    },
    dimensionTheme: {
        general: {
            '0px': 'var(--dimension-theme-general-0px, 0px)',
            '2px': 'var(--dimension-theme-general-2px, 2px)',
            '4px': 'var(--dimension-theme-general-4px, 4px)',
            '8px': 'var(--dimension-theme-general-8px, 8px)',
            '16px': 'var(--dimension-theme-general-16px, 16px)',
            '24px': 'var(--dimension-theme-general-24px, 24px)',
            '32px': 'var(--dimension-theme-general-32px, 32px)',
            '40px': 'var(--dimension-theme-general-40px, 40px)',
            '48px': 'var(--dimension-theme-general-48px, 48px)',
            '56px': 'var(--dimension-theme-general-56px, 56px)',
            '64px': 'var(--dimension-theme-general-64px, 64px)',
            '72px': 'var(--dimension-theme-general-72px, 72px)',
            '80px': 'var(--dimension-theme-general-80px, 80px)'
        }
    },
    size: {
        button: {
            xs: 'var(--size-button-xs, 24px)',
            s: 'var(--size-button-s, 32px)',
            m: 'var(--size-button-m, 40px)',
            l: 'var(--size-button-l, 48px)',
            mininalWidth: {
                xs: 'var(--size-button-mininal-width-xs, 72px)',
                s: 'var(--size-button-mininal-width-s, 96px)',
                m: 'var(--size-button-mininal-width-m, 120px)',
                l: 'var(--size-button-mininal-width-l, 144px)'
            }
        },
        colorPicker: {
            colorPreview: 'var(--size-color-picker-color-preview, 16px)',
            colorSlider: 'var(--size-color-picker-color-slider, 16px)',
            colorPalette: {
                colorArea: 'var(--size-color-picker-color-palette-color-area, 240px)',
                sliderTrack: 'var(--size-color-picker-color-palette-slider-track, 16px)'
            }
        },
        skeletonText: {
            lineHeight: {
                display: {
                    s: 'var(--size-skeleton-text-line-height-display-s, 48px)',
                    m: 'var(--size-skeleton-text-line-height-display-m, 60px)',
                    l: 'var(--size-skeleton-text-line-height-display-l, 72px)'
                },
                headline: {
                    s: 'var(--size-skeleton-text-line-height-headline-s, 32px)',
                    m: 'var(--size-skeleton-text-line-height-headline-m, 36px)',
                    l: 'var(--size-skeleton-text-line-height-headline-l, 40px)'
                },
                title: {
                    s: 'var(--size-skeleton-text-line-height-title-s, 20px)',
                    m: 'var(--size-skeleton-text-line-height-title-m, 24px)',
                    l: 'var(--size-skeleton-text-line-height-title-l, 28px)'
                },
                label: {
                    s: 'var(--size-skeleton-text-line-height-label-s, 14px)',
                    m: 'var(--size-skeleton-text-line-height-label-m, 16px)',
                    l: 'var(--size-skeleton-text-line-height-label-l, 20px)'
                },
                body: {
                    s: 'var(--size-skeleton-text-line-height-body-s, 16px)',
                    m: 'var(--size-skeleton-text-line-height-body-m, 20px)',
                    l: 'var(--size-skeleton-text-line-height-body-l, 24px)'
                }
            },
            fontSize: {
                display: {
                    s: 'var(--size-skeleton-text-font-size-display-s, 40px)',
                    m: 'var(--size-skeleton-text-font-size-display-m, 48px)',
                    l: 'var(--size-skeleton-text-font-size-display-l, 56px)'
                },
                headline: {
                    s: 'var(--size-skeleton-text-font-size-headline-s, 24px)',
                    m: 'var(--size-skeleton-text-font-size-headline-m, 28px)',
                    l: 'var(--size-skeleton-text-font-size-headline-l, 32px)'
                },
                title: {
                    s: 'var(--size-skeleton-text-font-size-title-s, 14px)',
                    m: 'var(--size-skeleton-text-font-size-title-m, 16px)',
                    l: 'var(--size-skeleton-text-font-size-title-l, 20px)'
                },
                label: {
                    s: 'var(--size-skeleton-text-font-size-label-s, 11px)',
                    m: 'var(--size-skeleton-text-font-size-label-m, 12px)',
                    l: 'var(--size-skeleton-text-font-size-label-l, 14px)'
                },
                body: {
                    s: 'var(--size-skeleton-text-font-size-body-s, 12px)',
                    m: 'var(--size-skeleton-text-font-size-body-m, 14px)',
                    l: 'var(--size-skeleton-text-font-size-body-l, 16px)'
                }
            }
        },
        loader: {
            loader: {
                xxs: 'var(--size-loader-loader-xxs, 8px)',
                xs: 'var(--size-loader-loader-xs, 16px)',
                s: 'var(--size-loader-loader-s, 24px)',
                m: 'var(--size-loader-loader-m, 48px)',
                l: 'var(--size-loader-loader-l, 72px)'
            }
        },
        progressBar: {
            progressBarPage: {
                height: {
                    xs: 'var(--size-progress-bar-progress-bar-page-height-xs, 2px)'
                }
            },
            progressBar: {
                height: {
                    xs: 'var(--size-progress-bar-progress-bar-height-xs, 2px)',
                    s: 'var(--size-progress-bar-progress-bar-height-s, 4px)'
                }
            }
        },
        card: {
            picture: {
                s: 'var(--size-card-picture-s, 32px)',
                m: 'var(--size-card-picture-m, 40px)',
                l: 'var(--size-card-picture-l, 80px)'
            },
            functionBadge: {
                functionRow: 'var(--size-card-function-badge-function-row, 32px)'
            },
            imageLitte: 'var(--size-card-image-litte, 144px)',
            imageMiddle: 'var(--size-card-image-middle, 240px)',
            check: 'var(--size-card-check, 16px)',
            button: 'var(--size-card-button, 32px)'
        },
        modal: {
            buttonClose: 'var(--size-modal-button-close, 32px)',
            minWidth: {
                s: 'var(--size-modal-min-width-s, 304px)',
                m: 'var(--size-modal-min-width-m, 304px)',
                l: 'var(--size-modal-min-width-l, 304px)'
            },
            width: {
                s: 'var(--size-modal-width-s, 464px)',
                m: 'var(--size-modal-width-m, 864px)',
                l: 'var(--size-modal-width-l, 1872px)'
            },
            headerElements: 'var(--size-modal-header-elements, 64px)',
            image: 'var(--size-modal-image, 184px)'
        },
        link: {
            s: 'var(--size-link-s, 16px)',
            m: 'var(--size-link-m, 20px)',
            l: 'var(--size-link-l, 24px)'
        },
        avatar: {
            xxs: 'var(--size-avatar-xxs, 16px)',
            xs: 'var(--size-avatar-xs, 24px)',
            s: 'var(--size-avatar-s, 32px)',
            m: 'var(--size-avatar-m, 48px)',
            l: 'var(--size-avatar-l, 64px)',
            xl: 'var(--size-avatar-xl, 88px)',
            xxl: 'var(--size-avatar-xxl, 112px)'
        },
        statusIndicator: {
            xxs: 'var(--size-status-indicator-xxs, 4px)',
            xs: 'var(--size-status-indicator-xs, 8px)',
            s: 'var(--size-status-indicator-s, 12px)',
            m: 'var(--size-status-indicator-m, 16px)',
            l: 'var(--size-status-indicator-l, 24px)'
        },
        status: {
            backgroundContainer: {
                xs: 'var(--size-status-background-container-xs, 16px)',
                s: 'var(--size-status-background-container-s, 24px)'
            }
        },
        statusIndicatorContainer: {
            xxs: 'var(--size-status-indicator-container-xxs, 4px)',
            xs: 'var(--size-status-indicator-container-xs, 8px)',
            s: 'var(--size-status-indicator-container-s, 16px)',
            m: 'var(--size-status-indicator-container-m, 16px)',
            l: 'var(--size-status-indicator-container-l, 24px)'
        },
        counter: {
            s: {
                minimalWidth: 'var(--size-counter-s-minimal-width, 16px)',
                height: 'var(--size-counter-s-height, 16px)'
            },
            m: {
                minimalWidth: 'var(--size-counter-m-minimal-width, 24px)',
                height: 'var(--size-counter-m-height, 24px)'
            }
        },
        pagination: {
            pageButton: {
                size: {
                    xs: 'var(--size-pagination-page-button-size-xs, 24px)',
                    s: 'var(--size-pagination-page-button-size-s, 32px)'
                }
            },
            pageButtonSlider: {
                container: 'var(--size-pagination-page-button-slider-container, 24px)',
                dotPage: {
                    default: 'var(--size-pagination-page-button-slider-dot-page-default, 8px)',
                    interaction: 'var(--size-pagination-page-button-slider-dot-page-interaction, 12px)'
                }
            }
        },
        toggles: {
            s: {
                container: 'var(--size-toggles-s-container, 16px)',
                containerSwitchWidth: 'var(--size-toggles-s-container-switch-width, 24px)',
                box: {
                    checkbox: 'var(--size-toggles-s-box-checkbox, 16px)',
                    radio: 'var(--size-toggles-s-box-radio, 16px)',
                    switchWidth: 'var(--size-toggles-s-box-switch-width, 24px)',
                    switchHeight: 'var(--size-toggles-s-box-switch-height, 16px)'
                },
                flag: {
                    radio: 'var(--size-toggles-s-flag-radio, 8px)',
                    switch: 'var(--size-toggles-s-flag-switch, 12px)'
                }
            },
            m: {
                container: 'var(--size-toggles-m-container, 24px)',
                containerSwitchWidth: 'var(--size-toggles-m-container-switch-width, 36px)',
                box: {
                    checkbox: 'var(--size-toggles-m-box-checkbox, 20px)',
                    radio: 'var(--size-toggles-m-box-radio, 20px)',
                    switchWidth: 'var(--size-toggles-m-box-switch-width, 32px)',
                    switchHeight: 'var(--size-toggles-m-box-switch-height, 20px)'
                },
                flag: {
                    radio: 'var(--size-toggles-m-flag-radio, 12px)',
                    switch: 'var(--size-toggles-m-flag-switch, 16px)'
                }
            }
        },
        popover: {
            popoverPointer: {
                arrow: {
                    width: 'var(--size-popover-popover-pointer-arrow-width, 6px)',
                    height: 'var(--size-popover-popover-pointer-arrow-height, 12px)'
                }
            },
            container: {
                minWidth: 'var(--size-popover-container-min-width, 28px)',
                maxWidth: 'var(--size-popover-container-max-width, 1200px)'
            }
        },
        scroll: {
            buttonResize: 'var(--size-scroll-button-resize, 16px)',
            track: {
                s: 'var(--size-scroll-track-s, 8px)',
                m: 'var(--size-scroll-track-m, 16px)'
            },
            slider: {
                s: 'var(--size-scroll-slider-s, 4px)',
                m: 'var(--size-scroll-slider-m, 6px)'
            }
        },
        tabs: {
            primary: {
                height: 'var(--size-tabs-primary-height, 56px)'
            },
            tabButtonPrimary: {
                container: 'var(--size-tabs-tab-button-primary-container, 44px)',
                marker: 'var(--size-tabs-tab-button-primary-marker, 2px)'
            },
            secondary: {
                height: 'var(--size-tabs-secondary-height, 32px)'
            },
            tabButtonSecondary: {
                container: 'var(--size-tabs-tab-button-secondary-container, 20px)',
                marker: 'var(--size-tabs-tab-button-secondary-marker, 2px)'
            }
        },
        chips: {
            xs: 'var(--size-chips-xs, 24px)',
            s: 'var(--size-chips-s, 32px)',
            m: 'var(--size-chips-m, 40px)',
            l: 'var(--size-chips-l, 48px)'
        },
        breadcrumbs: {
            xs: 'var(--size-breadcrumbs-xs, 16px)',
            s: 'var(--size-breadcrumbs-s, 24px)'
        },
        tagList: {
            maxWidth: {
                xs: 'var(--size-tag-list-max-width-xs, 256px)',
                s: 'var(--size-tag-list-max-width-s, 280px)'
            }
        },
        tag: {
            xs: 'var(--size-tag-xs, 24px)',
            s: 'var(--size-tag-s, 32px)'
        },
        iconPredefined: {
            container: {
                s: 'var(--size-icon-predefined-container-s, 32px)',
                m: 'var(--size-icon-predefined-container-m, 40px)',
                l: 'var(--size-icon-predefined-container-l, 80px)'
            }
        },
        icon: {
            container: {
                xs: 'var(--size-icon-container-xs, 16px)',
                s: 'var(--size-icon-container-s, 24px)',
                sx2: 'var(--size-icon-container-sx2, 48px)'
            }
        },
        fields: {
            s: 'var(--size-fields-s, 32px)',
            m: 'var(--size-fields-m, 40px)',
            l: 'var(--size-fields-l, 48px)',
            scrollBar: {
                width: 'var(--size-fields-scroll-bar-width, 8px)'
            },
            buttons: {
                s: 'var(--size-fields-buttons-s, 16px)',
                m: 'var(--size-fields-buttons-m, 24px)'
            },
            buttonField: {
                s: 'var(--size-fields-button-field-s, 28px)',
                m: 'var(--size-fields-button-field-m, 36px)',
                l: 'var(--size-fields-button-field-l, 44px)'
            },
            hint: {
                iconContainer: {
                    s: 'var(--size-fields-hint-icon-container-s, 16px)',
                    m: 'var(--size-fields-hint-icon-container-m, 20px)'
                }
            }
        },
        calendar: {
            button: {
                s: 'var(--size-calendar-button-s, 32px)',
                m: 'var(--size-calendar-button-m, 40px)',
                l: 'var(--size-calendar-button-l, 48px)'
            },
            markerHeight: 'var(--size-calendar-marker-height, 2px)',
            container: {
                header: {
                    linesHeight: {
                        s: 'var(--size-calendar-container-header-lines-height-s, 32px)',
                        m: 'var(--size-calendar-container-header-lines-height-m, 40px)',
                        l: 'var(--size-calendar-container-header-lines-height-l, 48px)'
                    }
                },
                minWidth: {
                    s: 'var(--size-calendar-container-min-width-s, 240px)',
                    m: 'var(--size-calendar-container-min-width-m, 296px)',
                    l: 'var(--size-calendar-container-min-width-l, 352px)'
                },
                minHeight: {
                    s: 'var(--size-calendar-container-min-height-s, 256px)',
                    m: 'var(--size-calendar-container-min-height-m, 320px)',
                    l: 'var(--size-calendar-container-min-height-l, 384px)'
                }
            },
            time: {
                minWidth: {
                    s: 'var(--size-calendar-time-min-width-s, 120px)',
                    m: 'var(--size-calendar-time-min-width-m, 144px)',
                    l: 'var(--size-calendar-time-min-width-l, 168px)'
                }
            }
        },
        dropList: {
            item: {
                headline: 'var(--size-drop-list-item-headline, 24px)',
                containerSeparatorSubheaderHeight: {
                    s: 'var(--size-drop-list-item-container-separator-subheader-height-s, 32px)',
                    m: 'var(--size-drop-list-item-container-separator-subheader-height-m, 40px)',
                    l: 'var(--size-drop-list-item-container-separator-subheader-height-l, 48px)'
                },
                marker: 'var(--size-drop-list-item-marker, 4px)',
                nestingLevelOffset: {
                    s: 'var(--size-drop-list-item-nesting-level-offset-s, 24px)',
                    m: 'var(--size-drop-list-item-nesting-level-offset-m, 24px)',
                    l: 'var(--size-drop-list-item-nesting-level-offset-l, 24px)'
                },
                nestingLevelGapCompensator: {
                    s: 'var(--size-drop-list-item-nesting-level-gap-compensator-s, 16px)',
                    m: 'var(--size-drop-list-item-nesting-level-gap-compensator-m, 16px)',
                    l: 'var(--size-drop-list-item-nesting-level-gap-compensator-l, 16px)'
                }
            },
            loadList: {
                height: 'var(--size-drop-list-load-list-height, 96px)'
            }
        },
        alert: {
            button: {
                m: 'var(--size-alert-button-m, 24px)',
                s: 'var(--size-alert-button-s, 16px)'
            }
        },
        alertTop: {
            button: 'var(--size-alert-top-button, 32px)'
        },
        toaster: {
            buttonCloseColumn: 'var(--size-toaster-button-close-column, 40px)',
            toast: {
                systemEvent: {
                    button: 'var(--size-toaster-toast-system-event-button, 32px)',
                    buttonClose: 'var(--size-toaster-toast-system-event-button-close, 24px)',
                    progressBar: 'var(--size-toaster-toast-system-event-progress-bar, 4px)',
                    container: 'var(--size-toaster-toast-system-event-container, 320px)'
                },
                userAction: {
                    container: 'var(--size-toaster-toast-user-action-container, 40px)'
                }
            }
        },
        stepper: {
            step: {
                trackLine: 'var(--size-stepper-step-track-line, 2px)',
                status: 'var(--size-stepper-step-status, 32px)'
            }
        },
        drawer: {
            buttonClose: 'var(--size-drawer-button-close, 32px)',
            headerElements: 'var(--size-drawer-header-elements, 64px)',
            image: 'var(--size-drawer-image, 184px)',
            minWidth: {
                s: 'var(--size-drawer-min-width-s, 304px)',
                m: 'var(--size-drawer-min-width-m, 304px)',
                l: 'var(--size-drawer-min-width-l, 304px)'
            },
            width: {
                s: 'var(--size-drawer-width-s, 464px)',
                m: 'var(--size-drawer-width-m, 864px)',
                l: 'var(--size-drawer-width-l, 1872px)'
            }
        },
        promoTag: {
            container: 'var(--size-promo-tag-container, 16px)'
        },
        inputPrivate: {
            buttonClearValue: {
                s: 'var(--size-input-private-button-clear-value-s, 16px)',
                m: 'var(--size-input-private-button-clear-value-m, 24px)'
            }
        },
        chipChoice: {
            buttonClearValue: {
                xxs: 'var(--size-chip-choice-button-clear-value-xxs, 16px)',
                xs: 'var(--size-chip-choice-button-clear-value-xs, 24px)'
            }
        },
        search: {
            s: 'var(--size-search-s, 32px)',
            m: 'var(--size-search-m, 40px)',
            l: 'var(--size-search-l, 48px)'
        },
        table: {
            head: {
                nameLayout: 'var(--size-table-head-name-layout, 24px)',
                checkColumn: 'var(--size-table-head-check-column, 40px)'
            },
            information: {
                minHight: 'var(--size-table-information-min-hight, 304px)'
            },
            lineHeight: 'var(--size-table-line-height, 40px)',
            cellStatusIndicator: {
                horizontal: 'var(--size-table-cell-status-indicator-horizontal, 4px)',
                vertical: 'var(--size-table-cell-status-indicator-vertical, 40px)'
            }
        },
        notificationPanel: {
            card: {
                iconType: 'var(--size-notification-panel-card-icon-type, 20px)'
            },
            button: 'var(--size-notification-panel-button, 32px)',
            readedDivider: 'var(--size-notification-panel-readed-divider, 32px)',
            panel: 'var(--size-notification-panel-panel, 464px)',
            container: 'var(--size-notification-panel-container, 388px)'
        },
        toolbar: {
            checkbox: 'var(--size-toolbar-checkbox, 40px)'
        },
        tree: {
            item: {
                height: 'var(--size-tree-item-height, 32px)',
                checkboxWrap: 'var(--size-tree-item-checkbox-wrap, 24px)',
                line: {
                    height: 'var(--size-tree-item-line-height, 32px)',
                    width: 'var(--size-tree-item-line-width, 24px)'
                }
            }
        },
        tooltip: {
            tooltipPointer: {
                arrow: {
                    width: 'var(--size-tooltip-tooltip-pointer-arrow-width, 6px)',
                    height: 'var(--size-tooltip-tooltip-pointer-arrow-height, 12px)'
                }
            },
            container: {
                minWidth: 'var(--size-tooltip-container-min-width, 20px)',
                maxWidth: 'var(--size-tooltip-container-max-width, 416px)'
            }
        },
        timeline: {
            track: {
                line: {
                    width: 'var(--size-timeline-track-line-width, 2px)',
                    beforeHeight: 'var(--size-timeline-track-line-before-height, 4px)'
                },
                dot: {
                    container: 'var(--size-timeline-track-dot-container, 16px)',
                    subEvent: 'var(--size-timeline-track-dot-sub-event, 8px)'
                }
            }
        },
        carousel: {
            control: {
                wrapWidth: 'var(--size-carousel-control-wrap-width, 20px)',
                container: 'var(--size-carousel-control-container, 40px)'
            }
        },
        slider: {
            handle: 'var(--size-slider-handle, 16px)',
            trackLine: 'var(--size-slider-track-line, 2px)',
            track: 'var(--size-slider-track, 16px)',
            scaleBar: {
                step: {
                    width: 'var(--size-slider-scale-bar-step-width, 2px)',
                    height: 'var(--size-slider-scale-bar-step-height, 4px)'
                }
            }
        },
        markdown: {
            tableCell: {
                height: 'var(--size-markdown-table-cell-height, 40px)'
            },
            quote: {
                minHeight: 'var(--size-markdown-quote-min-height, 36px)'
            },
            inlineCode: {
                height: 'var(--size-markdown-inline-code-height, 20px)'
            }
        },
        attachment: {
            startItem: {
                s: 'var(--size-attachment-start-item-s, 32px)',
                m: 'var(--size-attachment-start-item-m, 40px)'
            },
            container: {
                square: {
                    s: 'var(--size-attachment-container-square-s, 80px)',
                    m: 'var(--size-attachment-container-square-m, 108px)'
                }
            }
        },
        hotSpot: {
            dot: 'var(--size-hot-spot-dot, 8px)',
            pulse: 'var(--size-hot-spot-pulse, 16px)'
        },
        segmentedControl: {
            segment: {
                s: 'var(--size-segmented-control-segment-s, 28px)',
                m: 'var(--size-segmented-control-segment-m, 36px)',
                l: 'var(--size-segmented-control-segment-l, 44px)'
            }
        }
    },
    radius: {
        button: {
            xxs: 'var(--radius-button-xxs, 4px)',
            xs: 'var(--radius-button-xs, 4px)',
            s: 'var(--radius-button-s, 4px)',
            m: 'var(--radius-button-m, 4px)',
            l: 'var(--radius-button-l, 4px)'
        },
        colorPicker: {
            colorPreview: 'var(--radius-color-picker-color-preview, 4px)',
            colorSlider: 'var(--radius-color-picker-color-slider, 8px)',
            colorPalette: {
                sliderTrack: 'var(--radius-color-picker-color-palette-slider-track, 8px)'
            }
        },
        skeleton: {
            text: {
                display: {
                    s: 'var(--radius-skeleton-text-display-s, 20px)',
                    m: 'var(--radius-skeleton-text-display-m, 24px)',
                    l: 'var(--radius-skeleton-text-display-l, 28px)'
                },
                headline: {
                    s: 'var(--radius-skeleton-text-headline-s, 12px)',
                    m: 'var(--radius-skeleton-text-headline-m, 14px)',
                    l: 'var(--radius-skeleton-text-headline-l, 16px)'
                },
                title: {
                    s: 'var(--radius-skeleton-text-title-s, 7px)',
                    m: 'var(--radius-skeleton-text-title-m, 8px)',
                    l: 'var(--radius-skeleton-text-title-l, 10px)'
                },
                label: {
                    s: 'var(--radius-skeleton-text-label-s, 5.5px)',
                    m: 'var(--radius-skeleton-text-label-m, 6px)',
                    l: 'var(--radius-skeleton-text-label-l, 7px)'
                },
                body: {
                    s: 'var(--radius-skeleton-text-body-s, 6px)',
                    m: 'var(--radius-skeleton-text-body-m, 7px)',
                    l: 'var(--radius-skeleton-text-body-l, 8px)'
                }
            }
        },
        card: {
            container: 'var(--radius-card-container, 8px)',
            picture: 'var(--radius-card-picture, 4px)',
            check: 'var(--radius-card-check, 4px)',
            button: 'var(--radius-card-button, 4px)'
        },
        modal: {
            buttonClose: 'var(--radius-modal-button-close, 16px)',
            modalWindow: 'var(--radius-modal-modal-window, 12px)'
        },
        iconPredefined: {
            decorRound: {
                s: 'var(--radius-icon-predefined-decor-round-s, 16px)',
                m: 'var(--radius-icon-predefined-decor-round-m, 24px)',
                l: 'var(--radius-icon-predefined-decor-round-l, 40px)'
            },
            decorSquare: {
                s: 'var(--radius-icon-predefined-decor-square-s, 4px)',
                m: 'var(--radius-icon-predefined-decor-square-m, 8px)',
                l: 'var(--radius-icon-predefined-decor-square-l, 12px)'
            }
        },
        tabs: {
            tabButtonPrimary: {
                container: 'var(--radius-tabs-tab-button-primary-container, 6px)',
                marker: 'var(--radius-tabs-tab-button-primary-marker, 0px)'
            },
            tabButtonSecondary: {
                container: 'var(--radius-tabs-tab-button-secondary-container, 6px)',
                marker: 'var(--radius-tabs-tab-button-secondary-marker, 2px)'
            }
        },
        toggles: {
            s: {
                container: 'var(--radius-toggles-s-container, 6px)',
                box: {
                    checkbox: 'var(--radius-toggles-s-box-checkbox, 4px)',
                    radio: 'var(--radius-toggles-s-box-radio, 16px)',
                    switch: 'var(--radius-toggles-s-box-switch, 16px)'
                }
            },
            m: {
                container: 'var(--radius-toggles-m-container, 6px)',
                box: {
                    checkbox: 'var(--radius-toggles-m-box-checkbox, 4px)',
                    radio: 'var(--radius-toggles-m-box-radio, 16px)',
                    switch: 'var(--radius-toggles-m-box-switch, 16px)'
                }
            }
        },
        dropZone: {
            single: 'var(--radius-drop-zone-single, 8px)'
        },
        counter: {
            xs: 'var(--radius-counter-xs, 4px)',
            s: 'var(--radius-counter-s, 8px)',
            m: 'var(--radius-counter-m, 16px)'
        },
        progressBar: {
            xs: 'var(--radius-progress-bar-xs, 2px)',
            s: 'var(--radius-progress-bar-s, 2px)'
        },
        statusIndicator: {
            xxs: 'var(--radius-status-indicator-xxs, 2px)',
            xs: 'var(--radius-status-indicator-xs, 4px)',
            s: 'var(--radius-status-indicator-s, 8px)',
            m: 'var(--radius-status-indicator-m, 8px)',
            l: 'var(--radius-status-indicator-l, 16px)'
        },
        status: {
            xs: 'var(--radius-status-xs, 2px)',
            s: 'var(--radius-status-s, 4px)'
        },
        avatar: {
            round: {
                xxs: 'var(--radius-avatar-round-xxs, 8px)',
                xs: 'var(--radius-avatar-round-xs, 16px)',
                s: 'var(--radius-avatar-round-s, 24px)',
                m: 'var(--radius-avatar-round-m, 24px)',
                l: 'var(--radius-avatar-round-l, 32px)',
                xl: 'var(--radius-avatar-round-xl, 48px)',
                xxl: 'var(--radius-avatar-round-xxl, 64px)'
            },
            square: {
                xxs: 'var(--radius-avatar-square-xxs, 4px)',
                xs: 'var(--radius-avatar-square-xs, 4px)',
                s: 'var(--radius-avatar-square-s, 4px)',
                m: 'var(--radius-avatar-square-m, 8px)',
                l: 'var(--radius-avatar-square-l, 12px)',
                xl: 'var(--radius-avatar-square-xl, 16px)',
                xxl: 'var(--radius-avatar-square-xxl, 20px)'
            }
        },
        pagination: {
            pageButton: {
                xs: 'var(--radius-pagination-page-button-xs, 4px)',
                s: 'var(--radius-pagination-page-button-s, 4px)'
            },
            pageButtonSlider: {
                dotPage: {
                    single: 'var(--radius-pagination-page-button-slider-dot-page-single, 8px)'
                }
            }
        },
        progressBarPage: {
            single: 'var(--radius-progress-bar-page-single, 0px)'
        },
        popover: {
            container: 'var(--radius-popover-container, 8px)'
        },
        tooltip: {
            container: 'var(--radius-tooltip-container, 4px)'
        },
        dropList: {
            container: 'var(--radius-drop-list-container, 4px)',
            marker: 'var(--radius-drop-list-marker, 4px)'
        },
        chips: {
            xs: 'var(--radius-chips-xs, 12px)',
            s: 'var(--radius-chips-s, 16px)',
            m: 'var(--radius-chips-m, 20px)',
            l: 'var(--radius-chips-l, 24px)'
        },
        tag: {
            xs: 'var(--radius-tag-xs, 4px)',
            s: 'var(--radius-tag-s, 4px)'
        },
        scroll: {
            slider: {
                s: 'var(--radius-scroll-slider-s, 2px)',
                m: 'var(--radius-scroll-slider-m, 4px)'
            }
        },
        fields: {
            s: 'var(--radius-fields-s, 4px)',
            m: 'var(--radius-fields-m, 4px)',
            l: 'var(--radius-fields-l, 4px)',
            buttons: {
                s: 'var(--radius-fields-buttons-s, 8px)',
                m: 'var(--radius-fields-buttons-m, 12px)'
            },
            buttonField: {
                s: 'var(--radius-fields-button-field-s, 3px)',
                m: 'var(--radius-fields-button-field-m, 3px)',
                l: 'var(--radius-fields-button-field-l, 3px)'
            }
        },
        calendar: {
            item: {
                s: 'var(--radius-calendar-item-s, 4px)',
                m: 'var(--radius-calendar-item-m, 4px)',
                l: 'var(--radius-calendar-item-l, 4px)'
            },
            button: {
                s: 'var(--radius-calendar-button-s, 4px)',
                m: 'var(--radius-calendar-button-m, 4px)',
                l: 'var(--radius-calendar-button-l, 4px)'
            },
            marker: 'var(--radius-calendar-marker, 2px)'
        },
        alert: {
            button: 'var(--radius-alert-button, 4px)',
            container: 'var(--radius-alert-container, 4px)'
        },
        alertTop: {
            button: 'var(--radius-alert-top-button, 4px)'
        },
        toaster: {
            toast: {
                systemEvent: {
                    container: 'var(--radius-toaster-toast-system-event-container, 8px)',
                    button: 'var(--radius-toaster-toast-system-event-button, 8px)'
                },
                userAction: {
                    container: 'var(--radius-toaster-toast-user-action-container, 8px)'
                }
            },
            systemEvent: {
                buttonCloseColumn: 'var(--radius-toaster-system-event-button-close-column, 8px)'
            }
        },
        stepper: {
            step: {
                status: 'var(--radius-stepper-step-status, 24px)',
                trackLine: 'var(--radius-stepper-step-track-line, 2px)'
            }
        },
        drawer: {
            buttonClose: 'var(--radius-drawer-button-close, 16px)'
        },
        promoTag: {
            container: 'var(--radius-promo-tag-container, 4px)'
        },
        inputPrivate: {
            buttonClearValue: {
                s: 'var(--radius-input-private-button-clear-value-s, 8px)',
                m: 'var(--radius-input-private-button-clear-value-m, 12px)'
            }
        },
        chipChoice: {
            buttonClearValue: {
                xxs: 'var(--radius-chip-choice-button-clear-value-xxs, 16px)',
                xs: 'var(--radius-chip-choice-button-clear-value-xs, 24px)'
            }
        },
        search: {
            s: 'var(--radius-search-s, 4px)',
            m: 'var(--radius-search-m, 4px)',
            l: 'var(--radius-search-l, 4px)'
        },
        table: {
            container: 'var(--radius-table-container, 4px)'
        },
        notificationPanel: {
            footer: {
                radiusBottom: 'var(--radius-notification-panel-footer-radius-bottom, 4px)'
            },
            panel: 'var(--radius-notification-panel-panel, 12px)'
        },
        toolbar: {
            checkbox: 'var(--radius-toolbar-checkbox, 4px)',
            container: 'var(--radius-toolbar-container, 4px)',
            search: 'var(--radius-toolbar-search, 4px)'
        },
        accordion: {
            collapseBlock: {
                primary: {
                    round: 'var(--radius-accordion-collapse-block-primary-round, 12px)',
                    square: 'var(--radius-accordion-collapse-block-primary-square, 4px)'
                }
            }
        },
        tree: {
            item: {
                contentLayout: 'var(--radius-tree-item-content-layout, 4px)'
            }
        },
        timeline: {
            dot: {
                event: 'var(--radius-timeline-dot-event, 16px)',
                subEvent: 'var(--radius-timeline-dot-sub-event, 8px)'
            }
        },
        carousel: {
            control: {
                container: 'var(--radius-carousel-control-container, 24px)'
            }
        },
        slider: {
            handle: 'var(--radius-slider-handle, 16px)',
            scaleBar: {
                step: {
                    line: 'var(--radius-slider-scale-bar-step-line, 2px)'
                }
            },
            trackLine: 'var(--radius-slider-track-line, 2px)'
        },
        markdown: {
            inlineCode: {
                container: 'var(--radius-markdown-inline-code-container, 4px)'
            },
            preview: {
                container: 'var(--radius-markdown-preview-container, 4px)'
            }
        },
        hotSpot: {
            dot: 'var(--radius-hot-spot-dot, 8px)',
            pulse: 'var(--radius-hot-spot-pulse, 16px)'
        },
        segmentedControl: {
            container: {
                s: 'var(--radius-segmented-control-container-s, 4px)',
                m: 'var(--radius-segmented-control-container-m, 4px)',
                l: 'var(--radius-segmented-control-container-l, 4px)'
            },
            segment: {
                s: 'var(--radius-segmented-control-segment-s, 2px)',
                m: 'var(--radius-segmented-control-segment-m, 2px)',
                l: 'var(--radius-segmented-control-segment-l, 2px)'
            }
        }
    },
    space: {
        button: {
            xxs: {
                fromIcon: 'var(--space-button-xxs-from-icon, 2px)',
                gap: 'var(--space-button-xxs-gap, 2px)',
                fromLabel: 'var(--space-button-xxs-from-label, 4px)'
            },
            xs: {
                fromIcon: 'var(--space-button-xs-from-icon, 4px)',
                gap: 'var(--space-button-xs-gap, 2px)',
                fromLabel: 'var(--space-button-xs-from-label, 8px)',
                fromButton: 'var(--space-button-xs-from-button, 0px)'
            },
            s: {
                fromIcon: 'var(--space-button-s-from-icon, 8px)',
                gap: 'var(--space-button-s-gap, 4px)',
                fromLabel: 'var(--space-button-s-from-label, 16px)',
                fromButton: 'var(--space-button-s-from-button, 0px)'
            },
            m: {
                fromIcon: 'var(--space-button-m-from-icon, 8px)',
                gap: 'var(--space-button-m-gap, 4px)',
                fromLabel: 'var(--space-button-m-from-label, 16px)'
            },
            l: {
                fromIcon: 'var(--space-button-l-from-icon, 16px)',
                gap: 'var(--space-button-l-gap, 4px)',
                fromLabel: 'var(--space-button-l-from-label, 24px)'
            }
        },
        colorPicker: {
            colorPalette: {
                gap: 'var(--space-color-picker-color-palette-gap, 8px)'
            },
            footer: {
                gap: 'var(--space-color-picker-footer-gap, 8px)'
            },
            colorModel: {
                gap: 'var(--space-color-picker-color-model-gap, 8px)'
            },
            gap: 'var(--space-color-picker-gap, 16px)',
            padding: 'var(--space-color-picker-padding, 4px)'
        },
        pagination: {
            gap: {
                container: 'var(--space-pagination-gap-container, 4px)'
            },
            pageButton: {
                xs: 'var(--space-pagination-page-button-xs, 4px)',
                s: 'var(--space-pagination-page-button-s, 8px)'
            }
        },
        link: {
            gap: {
                single: 'var(--space-link-gap-single, 0px)'
            }
        },
        card: {
            padding: {
                container: {
                    s: 'var(--space-card-padding-container-s, 8px)',
                    m: 'var(--space-card-padding-container-m, 16px)',
                    l: 'var(--space-card-padding-container-l, 24px)'
                },
                checkBadge: 'var(--space-card-padding-check-badge, 4px)',
                promoBadge: 'var(--space-card-padding-promo-badge, 4px)',
                functionBadge: 'var(--space-card-padding-function-badge, 8px)'
            },
            gap: {
                s: 'var(--space-card-gap-s, 4px)',
                m: 'var(--space-card-gap-m, 8px)',
                l: 'var(--space-card-gap-l, 16px)'
            }
        },
        fields: {
            postfix: {
                gap: 'var(--space-fields-postfix-gap, 4px)'
            },
            hint: {
                gap: 'var(--space-fields-hint-gap, 2px)',
                containerGap: 'var(--space-fields-hint-container-gap, 16px)'
            },
            label: {
                gap: 'var(--space-fields-label-gap, 2px)'
            },
            decorator: {
                singleGap: 'var(--space-fields-decorator-single-gap, 4px)'
            },
            singleLineContainer: {
                s: {
                    left: 'var(--space-fields-single-line-container-s-left, 7px)',
                    gap: 'var(--space-fields-single-line-container-s-gap, 4px)',
                    right: 'var(--space-fields-single-line-container-s-right, 7px)',
                    button: 'var(--space-fields-single-line-container-s-button, 0px)'
                },
                m: {
                    left: 'var(--space-fields-single-line-container-m-left, 9px)',
                    gap: 'var(--space-fields-single-line-container-m-gap, 4px)',
                    right: 'var(--space-fields-single-line-container-m-right, 9px)',
                    button: 'var(--space-fields-single-line-container-m-button, 0px)'
                },
                l: {
                    left: 'var(--space-fields-single-line-container-l-left, 11px)',
                    gap: 'var(--space-fields-single-line-container-l-gap, 8px)',
                    right: 'var(--space-fields-single-line-container-l-right, 11px)',
                    button: 'var(--space-fields-single-line-container-l-button, 0px)'
                }
            },
            multiLineContainer: {
                s: {
                    left: 'var(--space-fields-multi-line-container-s-left, 7px)',
                    right: 'var(--space-fields-multi-line-container-s-right, 2px)',
                    top: 'var(--space-fields-multi-line-container-s-top, 7px)',
                    bottom: 'var(--space-fields-multi-line-container-s-bottom, 2px)',
                    inputContainer: 'var(--space-fields-multi-line-container-s-input-container, 5px)'
                },
                m: {
                    left: 'var(--space-fields-multi-line-container-m-left, 9px)',
                    right: 'var(--space-fields-multi-line-container-m-right, 2px)',
                    top: 'var(--space-fields-multi-line-container-m-top, 9px)',
                    bottom: 'var(--space-fields-multi-line-container-m-bottom, 2px)',
                    inputContainer: 'var(--space-fields-multi-line-container-m-input-container, 7px)'
                },
                l: {
                    left: 'var(--space-fields-multi-line-container-l-left, 11px)',
                    right: 'var(--space-fields-multi-line-container-l-right, 2px)',
                    top: 'var(--space-fields-multi-line-container-l-top, 11px)',
                    bottom: 'var(--space-fields-multi-line-container-l-bottom, 2px)',
                    inputContainer: 'var(--space-fields-multi-line-container-l-input-container, 9px)'
                }
            },
            sliderPadding: {
                s: 'var(--space-fields-slider-padding-s, 8px)',
                m: 'var(--space-fields-slider-padding-m, 10px)',
                l: 'var(--space-fields-slider-padding-l, 12px)'
            },
            scaleBar: {
                paddingTop: 'var(--space-fields-scale-bar-padding-top, 7px)'
            },
            selectMultiple: {
                s: {
                    verticalPadding: 'var(--space-fields-select-multiple-s-vertical-padding, 2px)'
                },
                m: {
                    verticalPadding: 'var(--space-fields-select-multiple-m-vertical-padding, 6px)'
                },
                l: {
                    verticalPadding: 'var(--space-fields-select-multiple-l-vertical-padding, 6px)'
                }
            },
            stepper: {
                contentContainer: 'var(--space-fields-stepper-content-container, 4px)'
            }
        },
        tagMore: {
            dropOffset: 'var(--space-tag-more-drop-offset, 4px)',
            xs: {
                fromLabel: 'var(--space-tag-more-xs-from-label, 4px)'
            },
            s: {
                fromLabel: 'var(--space-tag-more-s-from-label, 4px)'
            }
        },
        modal: {
            iconDecor: 'var(--space-modal-icon-decor, 32px)',
            headlineLayout: {
                top: 'var(--space-modal-headline-layout-top, 32px)',
                bottom: 'var(--space-modal-headline-layout-bottom, 24px)',
                sideS: 'var(--space-modal-headline-layout-side-s, 32px)',
                sideM: 'var(--space-modal-headline-layout-side-m, 32px)',
                gap: 'var(--space-modal-headline-layout-gap, 8px)',
                badge: {
                    elementsLayout: {
                        gap: 'var(--space-modal-headline-layout-badge-elements-layout-gap, 16px)'
                    }
                },
                headline: 'var(--space-modal-headline-layout-headline, 4px)'
            },
            headerElements: {
                top: 'var(--space-modal-header-elements-top, 16px)',
                side: 'var(--space-modal-header-elements-side, 16px)'
            },
            body: {
                side: 'var(--space-modal-body-side, 32px)',
                topBottom: 'var(--space-modal-body-top-bottom, 4px)'
            },
            footer: {
                top: 'var(--space-modal-footer-top, 24px)',
                bottom: 'var(--space-modal-footer-bottom, 32px)',
                side: 'var(--space-modal-footer-side, 32px)',
                gap: 'var(--space-modal-footer-gap, 16px)',
                actionRowGap: 'var(--space-modal-footer-action-row-gap, 8px)'
            },
            outsideGap: 'var(--space-modal-outside-gap, 24px)'
        },
        tabs: {
            primary: {
                gap: 'var(--space-tabs-primary-gap, 0px)',
                scrollButtonLayout: 'var(--space-tabs-primary-scroll-button-layout, 12px)'
            },
            tabButtonPrimary: {
                padding: 'var(--space-tabs-tab-button-primary-padding, 24px)',
                primaryContainer: {
                    padding: 'var(--space-tabs-tab-button-primary-primary-container-padding, 24px)',
                    gap: 'var(--space-tabs-tab-button-primary-primary-container-gap, 8px)'
                }
            },
            secondary: {
                gap: 'var(--space-tabs-secondary-gap, 24px)',
                scrollButtonLayout: 'var(--space-tabs-secondary-scroll-button-layout, 2px)'
            },
            tabButtonSecondary: {
                horizontal: {
                    padding: 'var(--space-tabs-tab-button-secondary-horizontal-padding, 2px)'
                },
                vertical: {
                    padding: 'var(--space-tabs-tab-button-secondary-vertical-padding, 8px)'
                },
                container: {
                    padding: 'var(--space-tabs-tab-button-secondary-container-padding, 0px)',
                    gap: 'var(--space-tabs-tab-button-secondary-container-gap, 4px)'
                }
            },
            container: {
                gap: 'var(--space-tabs-container-gap, 8px)'
            }
        },
        breadcrumbs: {
            separatorPadding: {
                xs: 'var(--space-breadcrumbs-separator-padding-xs, 4px)',
                s: 'var(--space-breadcrumbs-separator-padding-s, 8px)'
            },
            container: 'var(--space-breadcrumbs-container, 2px)',
            crumb: {
                xs: {
                    gap: 'var(--space-breadcrumbs-crumb-xs-gap, 2px)'
                },
                s: {
                    gap: 'var(--space-breadcrumbs-crumb-s-gap, 2px)'
                }
            }
        },
        counter: {
            s: 'var(--space-counter-s, 2.5px)',
            m: 'var(--space-counter-m, 4.5px)'
        },
        popover: {
            popoverPointer: {
                offset: 'var(--space-popover-popover-pointer-offset, 4px)',
                padding: 'var(--space-popover-popover-pointer-padding, 8px)'
            },
            container: {
                padding: 'var(--space-popover-container-padding, 24px)'
            }
        },
        chips: {
            container: {
                padding: {
                    xs: 'var(--space-chips-container-padding-xs, 3px)',
                    s: 'var(--space-chips-container-padding-s, 3px)',
                    m: 'var(--space-chips-container-padding-m, 7px)',
                    l: 'var(--space-chips-container-padding-l, 11px)'
                }
            },
            labelLayout: {
                padding: {
                    xs: 'var(--space-chips-label-layout-padding-xs, 4px)',
                    s: 'var(--space-chips-label-layout-padding-s, 4px)',
                    m: 'var(--space-chips-label-layout-padding-m, 8px)',
                    l: 'var(--space-chips-label-layout-padding-l, 12px)'
                },
                gap: 'var(--space-chips-label-layout-gap, 2px)'
            },
            filterRow: {
                gap: 'var(--space-chips-filter-row-gap, 4px)'
            }
        },
        tag: {
            xs: {
                fromIcon: 'var(--space-tag-xs-from-icon, 8px)',
                gap: 'var(--space-tag-xs-gap, 2px)',
                fromLabel: 'var(--space-tag-xs-from-label, 8px)',
                fromButton: 'var(--space-tag-xs-from-button, 0px)'
            },
            s: {
                fromIcon: 'var(--space-tag-s-from-icon, 8px)',
                gap: 'var(--space-tag-s-gap, 2px)',
                fromLabel: 'var(--space-tag-s-from-label, 8px)',
                fromButton: 'var(--space-tag-s-from-button, 0px)'
            }
        },
        tagRow: {
            xs: {
                gap: 'var(--space-tag-row-xs-gap, 4px)'
            },
            s: {
                gap: 'var(--space-tag-row-s-gap, 4px)'
            }
        },
        calendar: {
            button: {
                m: {
                    gap: 'var(--space-calendar-button-m-gap, 4px)',
                    horizontalPadding: 'var(--space-calendar-button-m-horizontal-padding, 8px)'
                },
                s: {
                    gap: 'var(--space-calendar-button-s-gap, 4px)',
                    horizontalPadding: 'var(--space-calendar-button-s-horizontal-padding, 8px)'
                },
                l: {
                    gap: 'var(--space-calendar-button-l-gap, 4px)',
                    horizontalPadding: 'var(--space-calendar-button-l-horizontal-padding, 12px)'
                }
            },
            container: {
                s: 'var(--space-calendar-container-s, 8px)',
                m: 'var(--space-calendar-container-m, 8px)',
                l: 'var(--space-calendar-container-l, 8px)'
            },
            labelDecorator: 'var(--space-calendar-label-decorator, 2px)',
            footerElements: {
                s: 'var(--space-calendar-footer-elements-s, 8px)',
                m: 'var(--space-calendar-footer-elements-m, 8px)',
                l: 'var(--space-calendar-footer-elements-l, 8px)'
            }
        },
        dropList: {
            item: {
                l: {
                    container: {
                        horizontalPadding: 'var(--space-drop-list-item-l-container-horizontal-padding, 12px)',
                        verticalPadding: 'var(--space-drop-list-item-l-container-vertical-padding, 12px)',
                        gap: 'var(--space-drop-list-item-l-container-gap, 8px)',
                        headline: {
                            gap: 'var(--space-drop-list-item-l-container-headline-gap, 8px)'
                        }
                    },
                    containerSeparatorSubheader: {
                        verticalPadding: 'var(--space-drop-list-item-l-container-separator-subheader-vertical-padding, 6px)'
                    }
                },
                m: {
                    container: {
                        horizontalPadding: 'var(--space-drop-list-item-m-container-horizontal-padding, 10px)',
                        verticalPadding: 'var(--space-drop-list-item-m-container-vertical-padding, 8px)',
                        gap: 'var(--space-drop-list-item-m-container-gap, 8px)',
                        headline: {
                            gap: 'var(--space-drop-list-item-m-container-headline-gap, 8px)'
                        }
                    },
                    containerSeparatorSubheader: {
                        verticalPadding: 'var(--space-drop-list-item-m-container-separator-subheader-vertical-padding, 5px)'
                    }
                },
                s: {
                    container: {
                        horizontalPadding: 'var(--space-drop-list-item-s-container-horizontal-padding, 8px)',
                        verticalPadding: 'var(--space-drop-list-item-s-container-vertical-padding, 4px)',
                        gap: 'var(--space-drop-list-item-s-container-gap, 8px)',
                        headline: {
                            gap: 'var(--space-drop-list-item-s-container-headline-gap, 8px)'
                        }
                    },
                    containerSeparatorSubheader: {
                        verticalPadding: 'var(--space-drop-list-item-s-container-separator-subheader-vertical-padding, 4px)'
                    }
                },
                markerContainer: {
                    verticalPadding: 'var(--space-drop-list-item-marker-container-vertical-padding, 2px)'
                }
            },
            noData: {
                l: {
                    container: {
                        verticalPadding: 'var(--space-drop-list-no-data-l-container-vertical-padding, 20px)'
                    }
                },
                m: {
                    container: {
                        verticalPadding: 'var(--space-drop-list-no-data-m-container-vertical-padding, 18px)'
                    }
                },
                s: {
                    container: {
                        verticalPadding: 'var(--space-drop-list-no-data-s-container-vertical-padding, 16px)'
                    }
                }
            },
            dropOffset: 'var(--space-drop-list-drop-offset, 4px)',
            container: {
                verticalPadding: 'var(--space-drop-list-container-vertical-padding, 4px)'
            }
        },
        alert: {
            m: {
                container: {
                    verticalPadding: 'var(--space-alert-m-container-vertical-padding, 15px)',
                    horizontalPadding: 'var(--space-alert-m-container-horizontal-padding, 15px)',
                    gap: 'var(--space-alert-m-container-gap, 15px)',
                    body: {
                        gap: 'var(--space-alert-m-container-body-gap, 8px)'
                    },
                    footer: {
                        gap: 'var(--space-alert-m-container-footer-gap, 16px)'
                    },
                    contentLayout: {
                        paddingTop: 'var(--space-alert-m-container-content-layout-padding-top, 2px)'
                    }
                },
                button: {
                    gap: 'var(--space-alert-m-button-gap, 4px)'
                }
            },
            s: {
                container: {
                    verticalPadding: 'var(--space-alert-s-container-vertical-padding, 7px)',
                    horizontalPadding: 'var(--space-alert-s-container-horizontal-padding, 7px)',
                    gap: 'var(--space-alert-s-container-gap, 7px)',
                    body: {
                        gap: 'var(--space-alert-s-container-body-gap, 4px)'
                    },
                    footer: {
                        gap: 'var(--space-alert-s-container-footer-gap, 16px)'
                    },
                    contentLayout: {
                        paddingTop: 'var(--space-alert-s-container-content-layout-padding-top, 0px)'
                    }
                },
                button: {
                    gap: 'var(--space-alert-s-button-gap, 4px)'
                }
            }
        },
        alertTop: {
            container: {
                verticalPadding: 'var(--space-alert-top-container-vertical-padding, 8px)',
                horizontalPadding: 'var(--space-alert-top-container-horizontal-padding, 16px)',
                gap: 'var(--space-alert-top-container-gap, 16px)',
                contentLayout: {
                    gap: 'var(--space-alert-top-container-content-layout-gap, 2px)'
                }
            },
            button: {
                gap: 'var(--space-alert-top-button-gap, 4px)',
                horizontalPadding: 'var(--space-alert-top-button-horizontal-padding, 12px)'
            }
        },
        toaster: {
            toast: {
                systemEvent: {
                    container: {
                        padding: 'var(--space-toaster-toast-system-event-container-padding, 12px)',
                        gap: 'var(--space-toaster-toast-system-event-container-gap, 12px)',
                        body: {
                            gap: 'var(--space-toaster-toast-system-event-container-body-gap, 16px)'
                        },
                        footer: {
                            gap: 'var(--space-toaster-toast-system-event-container-footer-gap, 8px)'
                        },
                        contentLayout: {
                            paddingTop: 'var(--space-toaster-toast-system-event-container-content-layout-padding-top, 2px)'
                        }
                    }
                },
                userAction: {
                    horizontPadding: 'var(--space-toaster-toast-user-action-horizont-padding, 8px)',
                    contentLayout: {
                        gap: 'var(--space-toaster-toast-user-action-content-layout-gap, 8px)',
                        horizontPadding: 'var(--space-toaster-toast-user-action-content-layout-horizont-padding, 8px)'
                    }
                }
            },
            systemEvent: {
                padding: 'var(--space-toaster-system-event-padding, 12px)',
                gap: 'var(--space-toaster-system-event-gap, 4px)'
            },
            userAction: {
                paddingBottom: 'var(--space-toaster-user-action-padding-bottom, 8px)',
                gap: 'var(--space-toaster-user-action-gap, 4px)'
            }
        },
        stepper: {
            step: {
                container: {
                    gap: 'var(--space-stepper-step-container-gap, 4px)',
                    paddingRight: 'var(--space-stepper-step-container-padding-right, 8px)'
                },
                track: {
                    gap: 'var(--space-stepper-step-track-gap, 8px)'
                }
            }
        },
        drawer: {
            iconDecor: 'var(--space-drawer-icon-decor, 32px)',
            headlineLayout: {
                top: 'var(--space-drawer-headline-layout-top, 32px)',
                bottom: 'var(--space-drawer-headline-layout-bottom, 24px)',
                sideS: 'var(--space-drawer-headline-layout-side-s, 32px)',
                sideM: 'var(--space-drawer-headline-layout-side-m, 32px)',
                gap: 'var(--space-drawer-headline-layout-gap, 8px)',
                badge: {
                    elementsLayout: {
                        gap: 'var(--space-drawer-headline-layout-badge-elements-layout-gap, 16px)'
                    }
                },
                headline: 'var(--space-drawer-headline-layout-headline, 4px)'
            },
            headerElements: {
                top: 'var(--space-drawer-header-elements-top, 16px)',
                side: 'var(--space-drawer-header-elements-side, 16px)'
            },
            body: {
                side: 'var(--space-drawer-body-side, 32px)'
            },
            footer: {
                top: 'var(--space-drawer-footer-top, 24px)',
                bottom: 'var(--space-drawer-footer-bottom, 32px)',
                side: 'var(--space-drawer-footer-side, 32px)',
                gap: 'var(--space-drawer-footer-gap, 16px)',
                actionRowGap: 'var(--space-drawer-footer-action-row-gap, 8px)'
            },
            outsideGap: 'var(--space-drawer-outside-gap, 24px)'
        },
        promoTag: {
            horizontalPadding: 'var(--space-promo-tag-horizontal-padding, 8px)'
        },
        search: {
            searchPrivate: {
                s: 'var(--space-search-search-private-s, 4px)',
                m: 'var(--space-search-search-private-m, 4px)',
                l: 'var(--space-search-search-private-l, 8px)'
            },
            container: {
                s: 'var(--space-search-container-s, 7px)',
                m: 'var(--space-search-container-m, 9px)',
                l: 'var(--space-search-container-l, 11px)'
            }
        },
        notificationPanel: {
            card: {
                functionBadge: {
                    paddingTop: 'var(--space-notification-panel-card-function-badge-padding-top, 12px)',
                    paddingRight: 'var(--space-notification-panel-card-function-badge-padding-right, 16px)'
                },
                paddingVertical: 'var(--space-notification-panel-card-padding-vertical, 16px)',
                paddingHorizontal: 'var(--space-notification-panel-card-padding-horizontal, 16px)',
                gap: 'var(--space-notification-panel-card-gap, 8px)',
                titleLayout: {
                    gap: 'var(--space-notification-panel-card-title-layout-gap, 4px)'
                }
            },
            header: {
                paddingTop: 'var(--space-notification-panel-header-padding-top, 24px)',
                horizontalPadding: 'var(--space-notification-panel-header-horizontal-padding, 16px)',
                paddingBottom: 'var(--space-notification-panel-header-padding-bottom, 16px)',
                gap: 'var(--space-notification-panel-header-gap, 16px)',
                chips: {
                    gap: 'var(--space-notification-panel-header-chips-gap, 8px)'
                },
                headline: {
                    gap: 'var(--space-notification-panel-header-headline-gap, 16px)'
                }
            },
            bodyInfo: {
                padding: 'var(--space-notification-panel-body-info-padding, 24px)'
            },
            blank: {
                text: {
                    gap: 'var(--space-notification-panel-blank-text-gap, 4px)'
                }
            },
            container: {
                paddingTop: 'var(--space-notification-panel-container-padding-top, 4px)',
                paddingBottom: 'var(--space-notification-panel-container-padding-bottom, 24px)'
            }
        },
        table: {
            cell: {
                padding: 'var(--space-table-cell-padding, 12px)',
                gap: 'var(--space-table-cell-gap, 4px)',
                paddingDivider: 'var(--space-table-cell-padding-divider, 8px)'
            },
            information: {
                gap: 'var(--space-table-information-gap, 24px)',
                padding: 'var(--space-table-information-padding, 24px)'
            },
            head: {
                separatorPadding: 'var(--space-table-head-separator-padding, 0px)',
                column: {
                    horizontalPadding: 'var(--space-table-head-column-horizontal-padding, 12px)',
                    verticalPadding: 'var(--space-table-head-column-vertical-padding, 8px)'
                }
            },
            header: {
                padding: 'var(--space-table-header-padding, 8px)',
                gap: 'var(--space-table-header-gap, 8px)'
            },
            footer: {
                padding: 'var(--space-table-footer-padding, 8px)',
                gap: 'var(--space-table-footer-gap, 8px)'
            },
            cellAction: {
                padding: 'var(--space-table-cell-action-padding, 4px)'
            }
        },
        toolbar: {
            search: {
                horizontalPadding: 'var(--space-toolbar-search-horizontal-padding, 8px)'
            },
            separatorPadding: 'var(--space-toolbar-separator-padding, 0px)'
        },
        accordion: {
            collapseBlock: {
                title: {
                    headline: {
                        gap: 'var(--space-accordion-collapse-block-title-headline-gap, 4px)'
                    },
                    gap: 'var(--space-accordion-collapse-block-title-gap, 16px)',
                    functionLayout: 'var(--space-accordion-collapse-block-title-function-layout, 8px)'
                },
                primary: {
                    verticalPadding: 'var(--space-accordion-collapse-block-primary-vertical-padding, 24px)',
                    horizontalPadding: 'var(--space-accordion-collapse-block-primary-horizontal-padding, 24px)',
                    gap: 'var(--space-accordion-collapse-block-primary-gap, 24px)'
                },
                secondary: {
                    verticalPadding: 'var(--space-accordion-collapse-block-secondary-vertical-padding, 16px)',
                    horizontalPadding: 'var(--space-accordion-collapse-block-secondary-horizontal-padding, 4px)',
                    gap: 'var(--space-accordion-collapse-block-secondary-gap, 16px)'
                }
            }
        },
        accordionPrimary: {
            gap: 'var(--space-accordion-primary-gap, 8px)'
        },
        accordionSecondary: {
            gap: 'var(--space-accordion-secondary-gap, 0px)'
        },
        tree: {
            item: {
                childLinePadding: 'var(--space-tree-item-child-line-padding, 8px)',
                contentLayout: {
                    gap: 'var(--space-tree-item-content-layout-gap, 4px)',
                    padding: 'var(--space-tree-item-content-layout-padding, 4px)'
                }
            }
        },
        tooltip: {
            tooltipPointer: {
                offset: 'var(--space-tooltip-tooltip-pointer-offset, 4px)',
                padding: 'var(--space-tooltip-tooltip-pointer-padding, 4px)'
            },
            padding: {
                single: 'var(--space-tooltip-padding-single, 8px)'
            }
        },
        filterRow: {
            gap: 'var(--space-filter-row-gap, 4px)'
        },
        timeline: {
            track: {
                padding: 'var(--space-timeline-track-padding, 4px)'
            },
            container: {
                gap: 'var(--space-timeline-container-gap, 16px)',
                contentLayout: {
                    padding: 'var(--space-timeline-container-content-layout-padding, 32px)'
                }
            }
        },
        carousel: {
            slidersWrap: {
                paddingTop: 'var(--space-carousel-sliders-wrap-padding-top, 8px)'
            },
            contentLayout: {
                padding: 'var(--space-carousel-content-layout-padding, 4px)'
            }
        },
        infoBlock: {
            s: {
                container: {
                    gap: 'var(--space-info-block-s-container-gap, 12px)',
                    contentLayout: {
                        gap: 'var(--space-info-block-s-container-content-layout-gap, 16px)',
                        textWrap: {
                            gap: 'var(--space-info-block-s-container-content-layout-text-wrap-gap, 4px)'
                        }
                    }
                }
            },
            m: {
                container: {
                    gap: 'var(--space-info-block-m-container-gap, 16px)',
                    contentLayout: {
                        gap: 'var(--space-info-block-m-container-content-layout-gap, 24px)',
                        textWrap: {
                            gap: 'var(--space-info-block-m-container-content-layout-text-wrap-gap, 8px)'
                        }
                    }
                }
            },
            l: {
                container: {
                    gap: 'var(--space-info-block-l-container-gap, 24px)',
                    contentLayout: {
                        gap: 'var(--space-info-block-l-container-content-layout-gap, 24px)',
                        textWrap: {
                            gap: 'var(--space-info-block-l-container-content-layout-text-wrap-gap, 8px)'
                        }
                    }
                }
            },
            footer: {
                gap: 'var(--space-info-block-footer-gap, 8px)'
            }
        },
        slider: {
            scaleBar: {
                step: {
                    gap: 'var(--space-slider-scale-bar-step-gap, 4px)'
                }
            }
        },
        markdown: {
            tableCell: {
                horizontalPadding: 'var(--space-markdown-table-cell-horizontal-padding, 16px)'
            },
            inlineCode: {
                horizontalPadding: 'var(--space-markdown-inline-code-horizontal-padding, 4px)'
            },
            quote: {
                horizontalPadding: 'var(--space-markdown-quote-horizontal-padding, 16px)',
                verticalPadding: 'var(--space-markdown-quote-vertical-padding, 8px)'
            },
            preview: {
                padding: 'var(--space-markdown-preview-padding, 14px)'
            },
            syntax: {
                heading: {
                    level1: 'var(--space-markdown-syntax-heading-level1, 20px)',
                    level2: 'var(--space-markdown-syntax-heading-level2, 18px)',
                    level3: 'var(--space-markdown-syntax-heading-level3, 16px)',
                    level4: 'var(--space-markdown-syntax-heading-level4, 14px)',
                    level5: 'var(--space-markdown-syntax-heading-level5, 12px)',
                    level6: 'var(--space-markdown-syntax-heading-level6, 10px)'
                },
                paragraphs: {
                    regular: 'var(--space-markdown-syntax-paragraphs-regular, 10px)',
                    bold: 'var(--space-markdown-syntax-paragraphs-bold, 10px)'
                },
                list: 'var(--space-markdown-syntax-list, 5px)',
                quote: 'var(--space-markdown-syntax-quote, 5px)',
                codeEditor: 'var(--space-markdown-syntax-code-editor, 5px)',
                table: 'var(--space-markdown-syntax-table, 5px)',
                divider: 'var(--space-markdown-syntax-divider, 10px)'
            }
        },
        attachment: {
            composition: {
                s: {
                    gap: 'var(--space-attachment-composition-s-gap, 8px)'
                },
                m: {
                    gap: 'var(--space-attachment-composition-m-gap, 12px)'
                },
                endItem: {
                    gap: 'var(--space-attachment-composition-end-item-gap, 4px)'
                }
            }
        },
        segmentedControl: {
            segment: {
                s: {
                    gap: 'var(--space-segmented-control-segment-s-gap, 4px)',
                    fromLabel: 'var(--space-segmented-control-segment-s-from-label, 16px)',
                    fromIcon: 'var(--space-segmented-control-segment-s-from-icon, 8px)',
                    iconOnly: 'var(--space-segmented-control-segment-s-icon-only, 2px)'
                },
                m: {
                    gap: 'var(--space-segmented-control-segment-m-gap, 4px)',
                    fromLabel: 'var(--space-segmented-control-segment-m-from-label, 16px)',
                    fromIcon: 'var(--space-segmented-control-segment-m-from-icon, 8px)',
                    iconOnly: 'var(--space-segmented-control-segment-m-icon-only, 6px)'
                },
                l: {
                    gap: 'var(--space-segmented-control-segment-l-gap, 4px)',
                    fromLabel: 'var(--space-segmented-control-segment-l-from-label, 24px)',
                    fromIcon: 'var(--space-segmented-control-segment-l-from-icon, 16px)',
                    iconOnly: 'var(--space-segmented-control-segment-l-icon-only, 10px)'
                }
            },
            container: {
                padding: 'var(--space-segmented-control-container-padding, 2px)'
            }
        }
    },
    borderWidth: {
        general: {
            xxs: 'var(--border-width-general-xxs, 0.5px)',
            xs: 'var(--border-width-general-xs, 1px)',
            s: 'var(--border-width-general-s, 1.5px)',
            m: 'var(--border-width-general-m, 2px)',
            l: 'var(--border-width-general-l, 3px)',
            xl: 'var(--border-width-general-xl, 4px)'
        },
        buttonOutline: {
            single: 'var(--border-width-button-outline-single, 2px)'
        },
        colorPicker: {
            colorSlider: 'var(--border-width-color-picker-color-slider, 4px)'
        },
        alert: {
            single: 'var(--border-width-alert-single, 1px)'
        },
        droplist: {
            pinContent: 'var(--border-width-droplist-pin-content, 1px)'
        },
        fields: {
            single: 'var(--border-width-fields-single, 1px)'
        },
        toggles: {
            single: 'var(--border-width-toggles-single, 2px)'
        },
        tagMore: {
            single: 'var(--border-width-tag-more-single, 2px)'
        },
        stateFocus: {
            s: 'var(--border-width-state-focus-s, 2px)',
            m: 'var(--border-width-state-focus-m, 3px)',
            l: 'var(--border-width-state-focus-l, 4px)'
        },
        counter: {
            single: 'var(--border-width-counter-single, 1.5px)'
        },
        card: {
            container: 'var(--border-width-card-container, 1px)',
            picture: 'var(--border-width-card-picture, 1px)'
        },
        chips: {
            single: 'var(--border-width-chips-single, 1px)'
        },
        search: {
            single: 'var(--border-width-search-single, 1px)'
        },
        notificationPanel: {
            container: 'var(--border-width-notification-panel-container, 1px)',
            card: 'var(--border-width-notification-panel-card, 1px)'
        },
        markdown: {
            tableCell: 'var(--border-width-markdown-table-cell, 1px)',
            quote: 'var(--border-width-markdown-quote, 4px)',
            preview: {
                container: 'var(--border-width-markdown-preview-container, 1px)'
            }
        },
        table: 'var(--border-width-table, 1px)',
        toolbar: {
            separator: 'var(--border-width-toolbar-separator, 1px)',
            outline: 'var(--border-width-toolbar-outline, 1px)'
        },
        stepper: {
            step: {
                status: 'var(--border-width-stepper-step-status, 2px)'
            }
        },
        accordion: {
            collapseBlock: {
                primary: 'var(--border-width-accordion-collapse-block-primary, 1px)',
                secondary: 'var(--border-width-accordion-collapse-block-secondary, 1px)'
            }
        },
        tree: {
            line: 'var(--border-width-tree-line, 1px)'
        },
        timeline: {
            track: {
                single: 'var(--border-width-timeline-track-single, 2px)'
            }
        },
        segmentedControl: {
            single: 'var(--border-width-segmented-control-single, 1px)'
        },
        '006m': 'var(--border-width-006m, 0.5px)',
        '012m': 'var(--border-width-012m, 1px)',
        '018m': 'var(--border-width-018m, 1.5px)',
        '025m': 'var(--border-width-025m, 2px)',
        '038m': 'var(--border-width-038m, 3px)',
        '050m': 'var(--border-width-050m, 4px)'
    },
    border: {
        stateFocus: {
            s: {
                'border-width': 'var(--border-state-focus-s-border-width, 2px)',
                'border-style': 'var(--border-state-focus-s-border-style, solid)',
                'border-color': 'var(--border-state-focus-s-border-color, )'
            },
            m: {
                'border-width': 'var(--border-state-focus-m-border-width, 3px)',
                'border-style': 'var(--border-state-focus-m-border-style, solid)',
                'border-color': 'var(--border-state-focus-m-border-color, )'
            },
            l: {
                'border-width': 'var(--border-state-focus-l-border-width, 4px)',
                'border-style': 'var(--border-state-focus-l-border-style, solid)',
                'border-color': 'var(--border-state-focus-l-border-color, )'
            }
        },
        dropZone: {
            single: {
                'border-width': 'var(--border-drop-zone-single-border-width, 2px)',
                'border-style': 'var(--border-drop-zone-single-border-style, dashed)'
            }
        },
        timeline: {
            trackLine: {
                dashed: {
                    'border-width': 'var(--border-timeline-track-line-dashed-border-width, 2px)',
                    'border-style': 'var(--border-timeline-track-line-dashed-border-style, dashed)'
                },
                solid: {
                    'border-width': 'var(--border-timeline-track-line-solid-border-width, 2px)',
                    'border-style': 'var(--border-timeline-track-line-solid-border-style, solid)'
                }
            }
        }
    },
    spacing: {
        stateFocus: {
            offset: 'var(--spacing-state-focus-offset, 2px)'
        },
        status: {
            backgroundContainer: {
                padding: {
                    left: {
                        xs: 'var(--spacing-status-background-container-padding-left-xs, 4px)',
                        s: 'var(--spacing-status-background-container-padding-left-s, 4px)'
                    },
                    right: {
                        xs: 'var(--spacing-status-background-container-padding-right-xs, 4px)',
                        s: 'var(--spacing-status-background-container-padding-right-s, 8px)'
                    }
                }
            },
            container: {
                gap: {
                    single: 'var(--spacing-status-container-gap-single, 2px)'
                }
            }
        },
        dropZone: {
            paddingHorizontal: 'var(--spacing-drop-zone-padding-horizontal, 8px)',
            paddingVertical: 'var(--spacing-drop-zone-padding-vertical, 8px)',
            gap: 'var(--spacing-drop-zone-gap, 4px)'
        }
    },
    opacity: {
        card: {
            transparentBackground: 'var(--opacity-card-transparent-background, 0.8)'
        },
        a0: 'var(--opacity-a0, 0)',
        a004: 'var(--opacity-a004, 0.04)',
        a008: 'var(--opacity-a008, 0.08)',
        a016: 'var(--opacity-a016, 0.16)',
        a024: 'var(--opacity-a024, 0.24)',
        a032: 'var(--opacity-a032, 0.32)',
        a040: 'var(--opacity-a040, 0.4)',
        a048: 'var(--opacity-a048, 0.48)',
        a056: 'var(--opacity-a056, 0.56)',
        a064: 'var(--opacity-a064, 0.64)',
        a072: 'var(--opacity-a072, 0.72)',
        a080: 'var(--opacity-a080, 0.8)',
        a088: 'var(--opacity-a088, 0.88)',
        a096: 'var(--opacity-a096, 0.96)'
    },
    sys: {
        neutral: {
            background: 'var(--sys-neutral-background, #eeeff3)',
            background1Level: 'var(--sys-neutral-background1-level, #fdfdfd)',
            background2Level: 'var(--sys-neutral-background2-level, #ffffff)',
            decorDefault: 'var(--sys-neutral-decor-default, #dde0ea)',
            decorHovered: 'var(--sys-neutral-decor-hovered, #cfd2dc)',
            decorActivated: 'var(--sys-neutral-decor-activated, #bec2cf)',
            decorDisabled: 'var(--sys-neutral-decor-disabled, #e6e8ef)',
            textMain: 'var(--sys-neutral-text-main, #41424e)',
            textSupport: 'var(--sys-neutral-text-support, #6d707f)',
            textLight: 'var(--sys-neutral-text-light, #8b8e9b)',
            textDisabled: 'var(--sys-neutral-text-disabled, #aaaebd)',
            accentDefault: 'var(--sys-neutral-accent-default, #787b8a)',
            accentHovered: 'var(--sys-neutral-accent-hovered, #6d707f)',
            accentPressed: 'var(--sys-neutral-accent-pressed, #656774)',
            onAccent: 'var(--sys-neutral-on-accent, #ffffff)'
        },
        primary: {
            background: 'var(--sys-primary-background, #f1f9f4)',
            background1Level: 'var(--sys-primary-background1-level, #f5fdf8)',
            background2Level: 'var(--sys-primary-background2-level, #fbfffc)',
            decorDefault: 'var(--sys-primary-decor-default, #caeadb)',
            decorHovered: 'var(--sys-primary-decor-hovered, #b3deca)',
            decorActivated: 'var(--sys-primary-decor-activated, #99d7ba)',
            decorDisabled: 'var(--sys-primary-decor-disabled, #e4f3eb)',
            textMain: 'var(--sys-primary-text-main, #1b5840)',
            textSupport: 'var(--sys-primary-text-support, #358561)',
            textLight: 'var(--sys-primary-text-light, #6aaf90)',
            textDisabled: 'var(--sys-primary-text-disabled, #84c4a5)',
            accentDefault: 'var(--sys-primary-accent-default, #389f74)',
            accentHovered: 'var(--sys-primary-accent-hovered, #37946e)',
            accentPressed: 'var(--sys-primary-accent-pressed, #358561)',
            onAccent: 'var(--sys-primary-on-accent, #fbfffc)'
        },
        red: {
            background: 'var(--sys-red-background, #fdf1ef)',
            background1Level: 'var(--sys-red-background1-level, #fef6f3)',
            background2Level: 'var(--sys-red-background2-level, #fffbf9)',
            decorDefault: 'var(--sys-red-decor-default, #fdd6cd)',
            decorHovered: 'var(--sys-red-decor-hovered, #fac1b3)',
            decorActivated: 'var(--sys-red-decor-activated, #fbab99)',
            decorDisabled: 'var(--sys-red-decor-disabled, #fee8e3)',
            textMain: 'var(--sys-red-text-main, #7a2d2d)',
            textSupport: 'var(--sys-red-text-support, #ae514c)',
            textLight: 'var(--sys-red-text-light, #e7756a)',
            textDisabled: 'var(--sys-red-text-disabled, #ee9285)',
            accentDefault: 'var(--sys-red-accent-default, #cb3f3e)',
            accentHovered: 'var(--sys-red-accent-hovered, #bd4844)',
            accentPressed: 'var(--sys-red-accent-pressed, #ae514c)',
            onAccent: 'var(--sys-red-on-accent, #fffbf9)'
        },
        orange: {
            background: 'var(--sys-orange-background, #fdf3df)',
            background1Level: 'var(--sys-orange-background1-level, #fdf8ed)',
            background2Level: 'var(--sys-orange-background2-level, #fffcf4)',
            decorDefault: 'var(--sys-orange-decor-default, #fed8b8)',
            decorHovered: 'var(--sys-orange-decor-hovered, #f8c699)',
            decorActivated: 'var(--sys-orange-decor-activated, #f5b27b)',
            decorDisabled: 'var(--sys-orange-decor-disabled, #fee8d2)',
            textMain: 'var(--sys-orange-text-main, #884c23)',
            textSupport: 'var(--sys-orange-text-support, #bb733e)',
            textLight: 'var(--sys-orange-text-light, #e78940)',
            textDisabled: 'var(--sys-orange-text-disabled, #ef9f5e)',
            accentDefault: 'var(--sys-orange-accent-default, #fb8e42)',
            accentHovered: 'var(--sys-orange-accent-hovered, #ec823b)',
            accentPressed: 'var(--sys-orange-accent-pressed, #e78940)',
            onAccent: 'var(--sys-orange-on-accent, #fffcf4)'
        },
        yellow: {
            background: 'var(--sys-yellow-background, #fef7e1)',
            background1Level: 'var(--sys-yellow-background1-level, #fcfbef)',
            background2Level: 'var(--sys-yellow-background2-level, #fffef6)',
            decorDefault: 'var(--sys-yellow-decor-default, #f0dfb1)',
            decorHovered: 'var(--sys-yellow-decor-hovered, #ead49a)',
            decorActivated: 'var(--sys-yellow-decor-activated, #e6c878)',
            decorDisabled: 'var(--sys-yellow-decor-disabled, #fcf0cc)',
            textMain: 'var(--sys-yellow-text-main, #815f19)',
            textSupport: 'var(--sys-yellow-text-support, #b78c32)',
            textLight: 'var(--sys-yellow-text-light, #d3a736)',
            textDisabled: 'var(--sys-yellow-text-disabled, #dcb65a)',
            accentDefault: 'var(--sys-yellow-accent-default, #e2b134)',
            accentHovered: 'var(--sys-yellow-accent-hovered, #d5a133)',
            accentPressed: 'var(--sys-yellow-accent-pressed, #d3a736)',
            onAccent: 'var(--sys-yellow-on-accent, #583f1f)'
        },
        green: {
            background: 'var(--sys-green-background, #f1fbee)',
            background1Level: 'var(--sys-green-background1-level, #f6fdf3)',
            background2Level: 'var(--sys-green-background2-level, #fcfefa)',
            decorDefault: 'var(--sys-green-decor-default, #d2ead0)',
            decorHovered: 'var(--sys-green-decor-hovered, #c0e1ba)',
            decorActivated: 'var(--sys-green-decor-activated, #a8d1a2)',
            decorDisabled: 'var(--sys-green-decor-disabled, #e3f6e1)',
            textMain: 'var(--sys-green-text-main, #3d6035)',
            textSupport: 'var(--sys-green-text-support, #55915a)',
            textLight: 'var(--sys-green-text-light, #69b56f)',
            textDisabled: 'var(--sys-green-text-disabled, #8dc88b)',
            accentDefault: 'var(--sys-green-accent-default, #57b762)',
            accentHovered: 'var(--sys-green-accent-hovered, #5daa63)',
            accentPressed: 'var(--sys-green-accent-pressed, #55915a)',
            onAccent: 'var(--sys-green-on-accent, #fcfefa)'
        },
        blue: {
            background: 'var(--sys-blue-background, #eef8ff)',
            background1Level: 'var(--sys-blue-background1-level, #f6fbff)',
            background2Level: 'var(--sys-blue-background2-level, #fdfeff)',
            decorDefault: 'var(--sys-blue-decor-default, #d6e2f4)',
            decorHovered: 'var(--sys-blue-decor-hovered, #c5d9f6)',
            decorActivated: 'var(--sys-blue-decor-activated, #aac4ea)',
            decorDisabled: 'var(--sys-blue-decor-disabled, #e6f0fd)',
            textMain: 'var(--sys-blue-text-main, #2b537e)',
            textSupport: 'var(--sys-blue-text-support, #4877b0)',
            textLight: 'var(--sys-blue-text-light, #749eda)',
            textDisabled: 'var(--sys-blue-text-disabled, #90b4e6)',
            accentDefault: 'var(--sys-blue-accent-default, #5388d1)',
            accentHovered: 'var(--sys-blue-accent-hovered, #4e80bf)',
            accentPressed: 'var(--sys-blue-accent-pressed, #4877b0)',
            onAccent: 'var(--sys-blue-on-accent, #fdfeff)'
        },
        violet: {
            background: 'var(--sys-violet-background, #f9f5ff)',
            background1Level: 'var(--sys-violet-background1-level, #fcfaff)',
            background2Level: 'var(--sys-violet-background2-level, #fdfdfd)',
            decorDefault: 'var(--sys-violet-decor-default, #e6dcf3)',
            decorHovered: 'var(--sys-violet-decor-hovered, #e1d0f7)',
            decorActivated: 'var(--sys-violet-decor-activated, #ceb7e7)',
            decorDisabled: 'var(--sys-violet-decor-disabled, #f4effd)',
            textMain: 'var(--sys-violet-text-main, #59446a)',
            textSupport: 'var(--sys-violet-text-support, #8c639b)',
            textLight: 'var(--sys-violet-text-light, #b68bd5)',
            textDisabled: 'var(--sys-violet-text-disabled, #c5a5e4)',
            accentDefault: 'var(--sys-violet-accent-default, #aa6cc1)',
            accentHovered: 'var(--sys-violet-accent-hovered, #9a66ae)',
            accentPressed: 'var(--sys-violet-accent-pressed, #8c639b)',
            onAccent: 'var(--sys-violet-on-accent, #fdfdfd)'
        },
        pink: {
            background: 'var(--sys-pink-background, #fcf2f5)',
            background1Level: 'var(--sys-pink-background1-level, #fdf9fa)',
            background2Level: 'var(--sys-pink-background2-level, #fdfcfc)',
            decorDefault: 'var(--sys-pink-decor-default, #f5d9e1)',
            decorHovered: 'var(--sys-pink-decor-hovered, #f5c9d6)',
            decorActivated: 'var(--sys-pink-decor-activated, #e8b1c1)',
            decorDisabled: 'var(--sys-pink-decor-disabled, #fee9ef)',
            textMain: 'var(--sys-pink-text-main, #754158)',
            textSupport: 'var(--sys-pink-text-support, #ae5e80)',
            textLight: 'var(--sys-pink-text-light, #db85a2)',
            textDisabled: 'var(--sys-pink-text-disabled, #e49cb3)',
            accentDefault: 'var(--sys-pink-accent-default, #d1668e)',
            accentHovered: 'var(--sys-pink-accent-hovered, #c06088)',
            accentPressed: 'var(--sys-pink-accent-pressed, #ae5e80)',
            onAccent: 'var(--sys-pink-on-accent, #fdfcfc)'
        },
        invertNeutral: {
            background: 'var(--sys-invert-neutral-background, #30303c)',
            decorDefault: 'var(--sys-invert-neutral-decor-default, #4e4f5a)',
            decorHovered: 'var(--sys-invert-neutral-decor-hovered, #656774)',
            decorActivated: 'var(--sys-invert-neutral-decor-activated, #6d707f)',
            decorDisabled: 'var(--sys-invert-neutral-decor-disabled, #41424e)',
            textMain: 'var(--sys-invert-neutral-text-main, #e6e8ef)',
            textSupport: 'var(--sys-invert-neutral-text-support, #bec2cf)',
            textLight: 'var(--sys-invert-neutral-text-light, #8b8e9b)',
            textDisabled: 'var(--sys-invert-neutral-text-disabled, #656774)',
            accentDefault: 'var(--sys-invert-neutral-accent-default, #cfd2dc)',
            accentHovered: 'var(--sys-invert-neutral-accent-hovered, #bec2cf)',
            accentPressed: 'var(--sys-invert-neutral-accent-pressed, #aaaebd)',
            onAccent: 'var(--sys-invert-neutral-on-accent, #393a46)'
        },
        opacity: {
            enabled: 'var(--sys-opacity-enabled, #ffffff29)',
            hovered: 'var(--sys-opacity-hovered, #ffffff3d)',
            activated: 'var(--sys-opacity-activated, #ffffff52)',
            disabled: 'var(--sys-opacity-disabled, #ffffff14)'
        },
        available: {
            complementary: 'var(--sys-available-complementary, #1c1c24)',
            onComplementary: 'var(--sys-available-on-complementary, #ffffff)'
        },
        blackout: 'var(--sys-blackout, #00000052)'
    },
    gradient: {
        linear: {
            mask: {
                '0deg': 'var(--gradient-linear-mask-0deg, linear-gradient(0deg, #ffffff00 0%, #ffffff14 33%, #ffffff 100%))',
                '90deg': 'var(--gradient-linear-mask-90deg, linear-gradient(90deg, #ffffff00 0%, #ffffff14 33%, #ffffff 100%))',
                '180deg': 'var(--gradient-linear-mask-180deg, linear-gradient(180deg, #ffffff00 0%, #ffffff14 33%, #ffffff 100%))',
                '270deg': 'var(--gradient-linear-mask-270deg, linear-gradient(270deg, #ffffff00 0%, #ffffff14 33%, #ffffff 100%))'
            }
        },
        skeleton: 'var(--gradient-skeleton, linear-gradient(115deg, #24243014 40%, #24243000 50%, #24243014 60%))'
    },
    ref: {
        gray: {
            '5': 'var(--ref-gray-5, #1c1c24)',
            '10': 'var(--ref-gray-10, #242430)',
            '15': 'var(--ref-gray-15, #2a2a36)',
            '20': 'var(--ref-gray-20, #30303c)',
            '25': 'var(--ref-gray-25, #393a46)',
            '30': 'var(--ref-gray-30, #41424e)',
            '35': 'var(--ref-gray-35, #4e4f5a)',
            '40': 'var(--ref-gray-40, #575966)',
            '45': 'var(--ref-gray-45, #656774)',
            '50': 'var(--ref-gray-50, #6d707f)',
            '55': 'var(--ref-gray-55, #787b8a)',
            '60': 'var(--ref-gray-60, #8b8e9b)',
            '65': 'var(--ref-gray-65, #aaaebd)',
            '70': 'var(--ref-gray-70, #bec2cf)',
            '75': 'var(--ref-gray-75, #cfd2dc)',
            '80': 'var(--ref-gray-80, #dde0ea)',
            '85': 'var(--ref-gray-85, #e6e8ef)',
            '90': 'var(--ref-gray-90, #eeeff3)',
            '95': 'var(--ref-gray-95, #fdfdfd)',
            '99': 'var(--ref-gray-99, #ffffff)'
        },
        brand: {
            '5': 'var(--ref-brand-5, #1b2422)',
            '10': 'var(--ref-brand-10, #1b2924)',
            '15': 'var(--ref-brand-15, #1b3028)',
            '20': 'var(--ref-brand-20, #1a392b)',
            '25': 'var(--ref-brand-25, #184a37)',
            '30': 'var(--ref-brand-30, #1b5840)',
            '35': 'var(--ref-brand-35, #236047)',
            '40': 'var(--ref-brand-40, #226748)',
            '45': 'var(--ref-brand-45, #358561)',
            '50': 'var(--ref-brand-50, #37946e)',
            '55': 'var(--ref-brand-55, #389f74)',
            '60': 'var(--ref-brand-60, #6aaf90)',
            '65': 'var(--ref-brand-65, #84c4a5)',
            '70': 'var(--ref-brand-70, #99d7ba)',
            '75': 'var(--ref-brand-75, #b3deca)',
            '80': 'var(--ref-brand-80, #caeadb)',
            '85': 'var(--ref-brand-85, #e4f3eb)',
            '90': 'var(--ref-brand-90, #f1f9f4)',
            '95': 'var(--ref-brand-95, #f5fdf8)',
            '99': 'var(--ref-brand-99, #fbfffc)'
        },
        red: {
            '5': 'var(--ref-red-5, #292020)',
            '10': 'var(--ref-red-10, #312323)',
            '15': 'var(--ref-red-15, #3a2727)',
            '20': 'var(--ref-red-20, #4e2525)',
            '25': 'var(--ref-red-25, #6a2729)',
            '30': 'var(--ref-red-30, #7a2d2d)',
            '35': 'var(--ref-red-35, #853332)',
            '40': 'var(--ref-red-40, #8e3a36)',
            '45': 'var(--ref-red-45, #ae514c)',
            '50': 'var(--ref-red-50, #bd4844)',
            '55': 'var(--ref-red-55, #cb3f3e)',
            '60': 'var(--ref-red-60, #e7756a)',
            '65': 'var(--ref-red-65, #ee9285)',
            '70': 'var(--ref-red-70, #fbab99)',
            '75': 'var(--ref-red-75, #fac1b3)',
            '80': 'var(--ref-red-80, #fdd6cd)',
            '85': 'var(--ref-red-85, #fee8e3)',
            '90': 'var(--ref-red-90, #fdf1ef)',
            '95': 'var(--ref-red-95, #fef6f3)',
            '99': 'var(--ref-red-99, #fffbf9)'
        },
        orange: {
            '5': 'var(--ref-orange-5, #292120)',
            '10': 'var(--ref-orange-10, #362621)',
            '15': 'var(--ref-orange-15, #412a20)',
            '20': 'var(--ref-orange-20, #57331f)',
            '25': 'var(--ref-orange-25, #74411e)',
            '30': 'var(--ref-orange-30, #884c23)',
            '35': 'var(--ref-orange-35, #915126)',
            '40': 'var(--ref-orange-40, #995527)',
            '45': 'var(--ref-orange-45, #bb733e)',
            '50': 'var(--ref-orange-50, #ec823b)',
            '55': 'var(--ref-orange-55, #fb8e42)',
            '60': 'var(--ref-orange-60, #e78940)',
            '65': 'var(--ref-orange-65, #ef9f5e)',
            '70': 'var(--ref-orange-70, #f5b27b)',
            '75': 'var(--ref-orange-75, #f8c699)',
            '80': 'var(--ref-orange-80, #fed8b8)',
            '85': 'var(--ref-orange-85, #fee8d2)',
            '90': 'var(--ref-orange-90, #fdf3df)',
            '95': 'var(--ref-orange-95, #fdf8ed)',
            '99': 'var(--ref-orange-99, #fffcf4)'
        },
        yellow: {
            '5': 'var(--ref-yellow-5, #29221c)',
            '10': 'var(--ref-yellow-10, #33271a)',
            '15': 'var(--ref-yellow-15, #42301b)',
            '20': 'var(--ref-yellow-20, #583f1f)',
            '25': 'var(--ref-yellow-25, #71521a)',
            '30': 'var(--ref-yellow-30, #815f19)',
            '35': 'var(--ref-yellow-35, #8b6515)',
            '40': 'var(--ref-yellow-40, #906910)',
            '45': 'var(--ref-yellow-45, #b78c32)',
            '50': 'var(--ref-yellow-50, #d5a133)',
            '55': 'var(--ref-yellow-55, #e2b134)',
            '60': 'var(--ref-yellow-60, #d3a736)',
            '65': 'var(--ref-yellow-65, #dcb65a)',
            '70': 'var(--ref-yellow-70, #e6c878)',
            '75': 'var(--ref-yellow-75, #ead49a)',
            '80': 'var(--ref-yellow-80, #f0dfb1)',
            '85': 'var(--ref-yellow-85, #fcf0cc)',
            '90': 'var(--ref-yellow-90, #fef7e1)',
            '95': 'var(--ref-yellow-95, #fcfbef)',
            '99': 'var(--ref-yellow-99, #fffef6)'
        },
        green: {
            '5': 'var(--ref-green-5, #1e211e)',
            '10': 'var(--ref-green-10, #212720)',
            '15': 'var(--ref-green-15, #273124)',
            '20': 'var(--ref-green-20, #2e3d29)',
            '25': 'var(--ref-green-25, #37502e)',
            '30': 'var(--ref-green-30, #3d6035)',
            '35': 'var(--ref-green-35, #426c3f)',
            '40': 'var(--ref-green-40, #437648)',
            '45': 'var(--ref-green-45, #55915a)',
            '50': 'var(--ref-green-50, #5daa63)',
            '55': 'var(--ref-green-55, #57b762)',
            '60': 'var(--ref-green-60, #69b56f)',
            '65': 'var(--ref-green-65, #8dc88b)',
            '70': 'var(--ref-green-70, #a8d1a2)',
            '75': 'var(--ref-green-75, #c0e1ba)',
            '80': 'var(--ref-green-80, #d2ead0)',
            '85': 'var(--ref-green-85, #e3f6e1)',
            '90': 'var(--ref-green-90, #f1fbee)',
            '95': 'var(--ref-green-95, #f6fdf3)',
            '99': 'var(--ref-green-99, #fcfefa)'
        },
        blue: {
            '5': 'var(--ref-blue-5, #1e222b)',
            '10': 'var(--ref-blue-10, #1d2736)',
            '15': 'var(--ref-blue-15, #202f40)',
            '20': 'var(--ref-blue-20, #213753)',
            '25': 'var(--ref-blue-25, #25466b)',
            '30': 'var(--ref-blue-30, #2b537e)',
            '35': 'var(--ref-blue-35, #325a84)',
            '40': 'var(--ref-blue-40, #35608f)',
            '45': 'var(--ref-blue-45, #4877b0)',
            '50': 'var(--ref-blue-50, #4e80bf)',
            '55': 'var(--ref-blue-55, #5388d1)',
            '60': 'var(--ref-blue-60, #749eda)',
            '65': 'var(--ref-blue-65, #90b4e6)',
            '70': 'var(--ref-blue-70, #aac4ea)',
            '75': 'var(--ref-blue-75, #c5d9f6)',
            '80': 'var(--ref-blue-80, #d6e2f4)',
            '85': 'var(--ref-blue-85, #e6f0fd)',
            '90': 'var(--ref-blue-90, #eef8ff)',
            '95': 'var(--ref-blue-95, #f6fbff)',
            '99': 'var(--ref-blue-99, #fdfeff)'
        },
        violet: {
            '5': 'var(--ref-violet-5, #231e2c)',
            '10': 'var(--ref-violet-10, #2b2535)',
            '15': 'var(--ref-violet-15, #332a40)',
            '20': 'var(--ref-violet-20, #3c314b)',
            '25': 'var(--ref-violet-25, #4c3d5f)',
            '30': 'var(--ref-violet-30, #59446a)',
            '35': 'var(--ref-violet-35, #614871)',
            '40': 'var(--ref-violet-40, #694c75)',
            '45': 'var(--ref-violet-45, #8c639b)',
            '50': 'var(--ref-violet-50, #9a66ae)',
            '55': 'var(--ref-violet-55, #aa6cc1)',
            '60': 'var(--ref-violet-60, #b68bd5)',
            '65': 'var(--ref-violet-65, #c5a5e4)',
            '70': 'var(--ref-violet-70, #ceb7e7)',
            '75': 'var(--ref-violet-75, #e1d0f7)',
            '80': 'var(--ref-violet-80, #e6dcf3)',
            '85': 'var(--ref-violet-85, #f4effd)',
            '90': 'var(--ref-violet-90, #f9f5ff)',
            '95': 'var(--ref-violet-95, #fcfaff)',
            '99': 'var(--ref-violet-99, #fdfdfd)'
        },
        pink: {
            '5': 'var(--ref-pink-5, #2e1e26)',
            '10': 'var(--ref-pink-10, #38232c)',
            '15': 'var(--ref-pink-15, #422632)',
            '20': 'var(--ref-pink-20, #502c3b)',
            '25': 'var(--ref-pink-25, #66394b)',
            '30': 'var(--ref-pink-30, #754158)',
            '35': 'var(--ref-pink-35, #7f445f)',
            '40': 'var(--ref-pink-40, #884764)',
            '45': 'var(--ref-pink-45, #ae5e80)',
            '50': 'var(--ref-pink-50, #c06088)',
            '55': 'var(--ref-pink-55, #d1668e)',
            '60': 'var(--ref-pink-60, #db85a2)',
            '65': 'var(--ref-pink-65, #e49cb3)',
            '70': 'var(--ref-pink-70, #e8b1c1)',
            '75': 'var(--ref-pink-75, #f5c9d6)',
            '80': 'var(--ref-pink-80, #f5d9e1)',
            '85': 'var(--ref-pink-85, #fee9ef)',
            '90': 'var(--ref-pink-90, #fcf2f5)',
            '95': 'var(--ref-pink-95, #fdf9fa)',
            '99': 'var(--ref-pink-99, #fdfcfc)'
        }
    },
    fontSizeMultiplier: 'var(--font-size-multiplier, 1px)',
    fontSize: {
        '11': 'var(--font-size-11, 11px)',
        '12': 'var(--font-size-12, 12px)',
        '14': 'var(--font-size-14, 14px)',
        '16': 'var(--font-size-16, 16px)',
        '20': 'var(--font-size-20, 20px)',
        '24': 'var(--font-size-24, 24px)',
        '28': 'var(--font-size-28, 28px)',
        '32': 'var(--font-size-32, 32px)',
        '36': 'var(--font-size-36, 36px)',
        '40': 'var(--font-size-40, 40px)',
        '48': 'var(--font-size-48, 48px)',
        '56': 'var(--font-size-56, 56px)'
    },
    fontFamily: {
        sbSansInterface: 'var(--font-family-sb-sans-interface, SB Sans Interface)',
        sbSansTextMono: 'var(--font-family-sb-sans-text-mono, SB Sans Text Mono)'
    },
    fontWeight: {
        regular: 'var(--font-weight-regular, Regular)',
        semiBold: 'var(--font-weight-semi-bold, Semibold)',
        bold: 'var(--font-weight-bold, Bold)',
        lightSans: 'var(--font-weight-light-sans, Light)'
    },
    lineHeightMultipler: 'var(--line-height-multipler, 4px)',
    paragraphSpacingMultipler: 'var(--paragraph-spacing-multipler, 0.55)',
    lineHeight: {
        display: {
            lg: 'var(--line-height-display-lg, 72px)',
            md: 'var(--line-height-display-md, 60px)',
            sm: 'var(--line-height-display-sm, 48px)'
        },
        headline: {
            lg: 'var(--line-height-headline-lg, 40px)',
            md: 'var(--line-height-headline-md, 36px)',
            sm: 'var(--line-height-headline-sm, 32px)'
        },
        title: {
            lg: 'var(--line-height-title-lg, 28px)',
            md: 'var(--line-height-title-md, 24px)',
            sm: 'var(--line-height-title-sm, 20px)'
        },
        label: {
            lg: 'var(--line-height-label-lg, 20px)',
            md: 'var(--line-height-label-md, 16px)',
            sm: 'var(--line-height-label-sm, 14px)'
        },
        body: {
            lg: 'var(--line-height-body-lg, 24px)',
            md: 'var(--line-height-body-md, 20px)',
            sm: 'var(--line-height-body-sm, 16px)'
        }
    },
    letterSpacing: {
        xs: 'var(--letter-spacing-xs, -0.5px)',
        s: 'var(--letter-spacing-s, 0px)',
        m: 'var(--letter-spacing-m, 0.1px)',
        l: 'var(--letter-spacing-l, 0.15px)'
    },
    textDecoration: {
        underline: 'var(--text-decoration-underline, underline)',
        lineThrough: 'var(--text-decoration-line-through, line-through)'
    },
    paragraphSpacing: {
        fontSize11: 'var(--paragraph-spacing-font-size11, 6.050000000000001px)',
        fontSize12: 'var(--paragraph-spacing-font-size12, 6.6000000000000005px)',
        fontSize14: 'var(--paragraph-spacing-font-size14, 7.700000000000001px)',
        fontSize16: 'var(--paragraph-spacing-font-size16, 8.8px)',
        fontSize22: 'var(--paragraph-spacing-font-size22, 11px)',
        fontSize24: 'var(--paragraph-spacing-font-size24, 13.200000000000001px)',
        fontSize28: 'var(--paragraph-spacing-font-size28, 15.400000000000002px)',
        fontSize32: 'var(--paragraph-spacing-font-size32, 17.6px)',
        fontSize36: 'var(--paragraph-spacing-font-size36, 19.8px)',
        fontSize40: 'var(--paragraph-spacing-font-size40, 22px)',
        fontSize48: 'var(--paragraph-spacing-font-size48, 26.400000000000002px)',
        fontSize56: 'var(--paragraph-spacing-font-size56, 30.800000000000004px)'
    },
    dimension: {
        '0m': 'var(--dimension-0m, 0px)',
        '025m': 'var(--dimension-025m, 2px)',
        '050m': 'var(--dimension-050m, 4px)',
        '1m': 'var(--dimension-1m, 8px)',
        '2m': 'var(--dimension-2m, 16px)',
        '3m': 'var(--dimension-3m, 24px)',
        '4m': 'var(--dimension-4m, 32px)',
        '5m': 'var(--dimension-5m, 40px)',
        '6m': 'var(--dimension-6m, 48px)',
        '7m': 'var(--dimension-7m, 56px)',
        '8m': 'var(--dimension-8m, 64px)',
        '9m': 'var(--dimension-9m, 72px)',
        '10m': 'var(--dimension-10m, 80px)'
    },
    dimensionModule: 'var(--dimension-module, 8px)',
    opacityMultiplier: 'var(--opacity-multiplier, 4)',
    px: 'var(--px, px)',
    borderStyles: {
        solid: 'var(--border-styles-solid, solid)',
        dashed: 'var(--border-styles-dashed, dashed)'
    }
};
